export const translations = {
  en: {
    // Navigation
    home: "Home",
    dashboard: "Dashboard",
    members: "Members",
    messages: "Messages",
    analysisAndReport: "Analysis & Report",
    plansAndReports: "Plans & Reports",
    selfRegistered: "Self Registered",
    trash: "Trash",
    supportTracking: "Support Tracking",
    supportReceived: "Support Received",
    management: "Management",
    galleryManagement: "Gallery Management",
    blogManagement: "Blog Management",
    settings: "Settings",
    profile: "Profile",
    accessibility: "Accessibility",
    logout: "Logout",
    logoutConfirmationTitle: "Are you sure you want to logout?",
    logoutConfirmationMessage: "You will be redirected to the login page.",
    cancel: "Cancel",
    yesLogout: "Yes, Logout",
    notifications: "Notifications",
    noNewNotifications: "No new Notifications",
    markAllAsRead: "Mark all as read",
    viewAll: "View all",
    viewMoreNotifications: "View {count} more notifications",
    
    // Admin Navigation
    allMembers: "All Members",
    pendingMembers: "Pending Members",
    rejectedMembers: "Rejected Members",
    renewals: "Renewals",
    opds: "OPDs",
    allOpds: "All OPDs",
    reports: "Reports",
    viewReports: "View Reports",
    management: "Management",
    galleryManagement: "Gallery Management",
    blogManagement: "Blog Management",
    programsManagement: "Programs Management",
    messages: "Messages",
    supportTracking: "Support Tracking",
    perMember: "Per-Member",
    perOpd: "Per-OPD",
    noPendingRequests: "No pending requests",
    markAllAsRead: "Mark all as read",
    onlineStatus: "Online",
    offlineStatus: "Offline",
    about: "About",
    whoWeAre: "Who We Are",
    leadership: "Leadership",
    Partnerss: "Partners",
    annualreport: "Annual Report",
    missionVisionValues: "Mission, Vision & Values",
    
    // LeadershipPage
    leadershipHeroTitle: "Leadership & Governance",
    leadershipHeroSubtitle: "Discover the dedicated leadership guiding the Addis Ababa Disability Association's mission for an inclusive society.",
    leadershipIntroTitle: "Leadership & Governance",
    leadershipIntroDesc: "At the heart of the Addis Ababa Disability Association is a leadership committed to advocacy, inclusion, and empowerment. Guided by Dr. Woinshet Girma Ayansa (Ph.D.), the association thrives on a vision of a fully inclusive society where persons with disabilities live with dignity, equality, and opportunity.",
    leaderAboutWoinshetTitle: "About Dr. Woinshet Girma Ayansa (Ph.D.)",
    leaderWoinshetName: "Dr. Woinshet Girma Ayansa",
    leaderWoinshetTitle: "President, Addis Ababa Disability Association",
    leaderWoinshetBio: "Woinshet Girma Ayansa (PhD) is a Deaf woman from Ethiopia, born into a hearing family. Despite the lack of sign language interpreters during her primary and secondary education, she pursued higher studies in linguistics, specializing in sign linguistics at Addis Ababa University, where she completed her BA, MA, and PhD. She later worked as a lecturer at the university and as the National Project Coordinator for the Ethiopian National Association of the Deaf. Passionate about Deaf advocacy, Woinshet founded the Hope for the Deaf Association, where she serves as Director, leading initiatives to promote the rights and inclusion of Deaf individuals. Currently, she serves as the President of the Addis Ababa Disability Association, continuing her advocacy for persons with disabilities at the national level.",
    leaderAchievement1: "Visionary Advocacy: Driving initiatives for sign language recognition and policy change",
    leaderAchievement2: "Community Empowerment: Creating programs that amplify the voices of persons with disabilities",
    leaderAchievement3: "Collaboration: Building partnerships with government, NGOs, and local communities",
    leaderAchievement4: "Education & Awareness: Promoting knowledge and understanding of disability rights and accessibility",
    leaderQuote: "We envision a city where disability is no barrier to opportunity. Our leadership is dedicated to breaking barriers, empowering ability, and transforming lives for every person with a disability in Addis Ababa.",
    leadershipAboutLabel: "About",
    leadershipFocusLabel: "Leadership Focus",
    leadershipVisionTitle: "Leadership Vision",
    leadershipGovernanceTitle: "Governance Structure",
    leadershipGovernanceDesc: "The Addis Ababa Disability Association is governed by a structured leadership body that ensures transparency, accountability, and participatory decision-making.",
    leadershipOrgStructureTitle: "Organizational Structure",
    leadershipPresident: "President",
    leadershipBoardOfDirectors: "Board of Directors",
    leadershipStrategicOversight: "Strategic Oversight",
    leadershipExecutiveCommittee: "Executive Committee",
    leadershipDailyManagement: "Daily Management",
    leadershipMemberAffairs: "Member Affairs Coordination",
    leadershipMembersOPDsGrassroots: "Members, OPDs & grassroots",
    leadershipGeneralManager: "General Manager",
    leadershipDayToDayCoord: "Day-to-day coordination",
    leadershipVariousCommittees: "Various Standing and Temporary Committees",
    leadershipFinanceAdmin: "Finance and Administration Service",
    leadershipCoordProjectPrintingIdentity: "Coordination of Project, Printing and Identity",
    leadershipOffice: "Office",
    leadershipCentralBranches: "Central & branches",
    leadershipBranchOffice: "Branch Office",
    leadershipKeyResponsibilities: "Key Responsibilities:",
    leadershipMembersVaries: "Varies",
    leadershipBoardDesc: "Strategic oversight body ensuring alignment with mission and approving major policies.",
    leadershipExecDesc: "Coordinates day-to-day operations and executes board directives.",
    leadershipMemberAffairsDesc: "Leads member relations, OPD engagement, and grassroots linkage.",
    leadershipGeneralManagerDesc: "Oversees day-to-day management and cross-program coordination.",
    leadershipOfficeDesc: "Central office functions and branch coordination.",
    leadershipBranchOfficeDesc: "Extends AAAPD services and representation to local levels.",
    leadershipStandingTemporaryCommittees: "Standing & Temporary Committees",
    leadershipStandingCommitteesDesc: "Thematic and ad‑hoc bodies supporting specialized initiatives.",
    leadershipFinanceAdminDesc: "Handles finance, HR, procurement, and administration.",
    leadershipCoordPPIRespDesc: "Coordinates projects, publications, and organizational identity.",
    leadershipRolePresidentTitle: "President / Chairperson",
    leadershipRolePresidentDesc: "Provides strategic leadership, public representation, and overall governance direction.",
    leadershipRolePresidentResp1: "Vision setting and strategic leadership",
    leadershipRolePresidentResp2: "High-level representation and advocacy",
    leadershipRolePresidentResp3: "Oversight of governance effectiveness",
    leadershipRolePresidentResp4: "Guidance to Board and Executive bodies",
    leadershipBoardResp1: "Strategic oversight and guidance",
    leadershipBoardResp2: "Policy approval and development",
    leadershipBoardResp3: "Risk management and compliance",
    leadershipBoardResp4: "Performance monitoring",
    leadershipExecResp1: "Operational decision-making",
    leadershipExecResp2: "Program execution and oversight",
    leadershipExecResp3: "Resource mobilization",
    leadershipExecResp4: "Partnership management",
    leadershipMemberResp1: "Member and OPD coordination",
    leadershipMemberResp2: "Grassroots engagement",
    leadershipMemberResp3: "Information and feedback flows",
    leadershipMemberResp4: "Local structure linkage",
    leadershipGMResp1: "Program and project coordination",
    leadershipGMResp2: "Staff and operations management",
    leadershipGMResp3: "Implementation oversight",
    leadershipGMResp4: "Reporting to Executive/Board",
    leadershipOfficeResp1: "Administrative services",
    leadershipOfficeResp2: "Branch coordination",
    leadershipOfficeResp3: "Logistics and office support",
    leadershipOfficeResp4: "Records and documentation",
    leadershipBranchResp1: "Local service delivery",
    leadershipBranchResp2: "Community liaison",
    leadershipBranchResp3: "Member support",
    leadershipBranchResp4: "Reporting to Office",
    leadershipCommitteesResp1: "Provide specialized input",
    leadershipCommitteesResp2: "Support project delivery",
    leadershipCommitteesResp3: "Ad-hoc task forces",
    leadershipCommitteesResp4: "Report to General Manager",
    leadershipFinanceResp1: "Financial management",
    leadershipFinanceResp2: "HR and procurement",
    leadershipFinanceResp3: "Compliance and controls",
    leadershipFinanceResp4: "Administrative support",
    leadershipPPIResp1: "Project coordination",
    leadershipPPIResp2: "Printing and publications",
    leadershipPPIResp3: "Brand and identity",
    leadershipPPIResp4: "Documentation management",
    leadershipPrinciplesTitle: "Governance Principles",
    leadershipPrinciplesHeadline: "Transparent Leadership. Inclusive Decision-Making.",
    leadershipPrinciplesSubAm: "Clear leadership, overall decision-making.",
    leadershipCtaTitle: "Join Our Leadership Journey",
    leadershipCtaDesc: "Be part of our mission to create an inclusive Addis Ababa. Whether you have leadership experience or want to develop your skills, we welcome passionate individuals committed to disability rights.",
    ourMissionButton: "Our Mission",
    // MissionVisionValuesPage (MVV)
    mvvHeroSubtitle: "Discover our commitment to empowering persons with disabilities and building an inclusive society in Addis Ababa.",
    // Mission
    mvvMissionTitle: "Mission",
    mvvMissionDesc: "Our mission is to promote dignity, equal rights, and full inclusion for persons with disabilities in Addis Ababa. We strive to create an accessible, inclusive society where disability is not a barrier to participation.",
    mvvWeWorkTo: "We work to:",
    mvvMissionPoint1Title: "Ensure equal participation for persons with disabilities",
    mvvMissionPoint1Desc: "Promoting inclusion so individuals with disabilities can fully engage in social, economic, and political life without barriers.",
    mvvMissionPoint2Title: "Advance equitable access and benefit",
    mvvMissionPoint2Desc: "Working to guarantee that persons with disabilities receive fair opportunities, services, and resources across all sectors.",
    mvvMissionPoint3Title: "Raise awareness on rights and responsibilities",
    mvvMissionPoint3Desc: "Providing education and community outreach to strengthen understanding of social, economic, and political rights for persons with disabilities.",
    mvvMissionPoint4Title: "Empower individuals through knowledge and support",
    mvvMissionPoint4Desc: "Building confidence, capacity, and leadership skills that enable persons with disabilities to advocate for themselves and participate actively in society.",
    // Vision
    mvvVisionTitle: "Vision",
    mvvVisionDesc: "An inclusive, barrier-free Addis Ababa where all persons with disabilities enjoy equal rights, participation, and dignity.",
    // Impact
    mvvImpactTitle: "Our Impact",
    mvvImpactIntro: "Over the years, the Addis Ababa Association of Persons with Disabilities has created meaningful change by empowering persons with disabilities and promoting their full participation in social, economic, and political life.",
    mvvImpact1Title: "Rights Protection & Advocacy",
    mvvImpact1Desc: "Working with government agencies and stakeholders to safeguard the rights and dignity of persons with disabilities, ensuring their voices are represented in policies, programs, and decision-making processes.",
    mvvImpact2Title: "Awareness & Inclusion Campaigns",
    mvvImpact2Desc: "Conducting education and outreach initiatives that raise awareness about disability rights, break down stigma, and foster inclusive attitudes across communities.",
    mvvImpact3Title: "Skills Development & Empowerment",
    mvvImpact3Desc: "Providing training, capacity-building programs, and educational opportunities that enable persons with disabilities to gain independence, leadership skills, and active community participation.",
    mvvImpact4Title: "Access to Services & Opportunities",
    mvvImpact4Desc: "Facilitating equitable access to healthcare, education, training, and employment, ensuring that persons with disabilities are supported as they pursue their social and economic goals.",
    mvvNetworkTitle: "Network Building",
    mvvNetworkDesc: "Collaborating with other local and national disability organizations to strengthen the disability movement in Ethiopia, creating a unified voice for change and progress.",
    // Values
    mvvValuesTitle: "Core Values",
    mvvValuesIntro: "These fundamental principles guide every aspect of our work and define our commitment to creating positive change.",
    mvvValue1Title: "Inclusivity",
    mvvValue1Desc: "Ensuring every person with a disability is welcomed, valued, and able to participate without discrimination.",
    mvvValue2Title: "Diligence",
    mvvValue2Desc: "Carrying out all responsibilities with commitment, discipline, and a strong work ethic to achieve meaningful impact.",
    mvvValue3Title: "Tolerance (Mutual Respect)",
    mvvValue3Desc: "Fostering an environment where diverse perspectives are respected, and differences are embraced with understanding and fairness.",
    mvvValue4Title: "Goodwill (Volunteerism)",
    mvvValue4Desc: "Encouraging a spirit of service, compassion, and community contribution in all activities and engagements.",
    mvvValue5Title: "Transparency and Accountability",
    mvvValue5Desc: "Upholding honesty, openness, and responsibility in decision-making, resource management, and organizational conduct.",
    mvvValue6Title: "Standing in Unity",
    mvvValue6Desc: "Working together with solidarity and shared purpose to advance the rights and wellbeing of persons with disabilities.",
    // Alignment
    mvvAlignmentTitle: "Alignment with ZOA's WaA Program",
    mvvAlignmentDesc: "AAAPD aligns closely with ZOA's WaA Program goals by promoting inclusion, empowerment, and resilience among persons with disabilities in Addis Ababa. Both organizations share a commitment to creating sustainable livelihoods, enhancing access to essential services, and strengthening community participation for marginalized groups. Through capacity building, advocacy, and inclusive development initiatives, AAAPD supports the WaA Program's vision of fostering self-reliant, dignified lives for all, particularly those affected by poverty, displacement, or disability.",
    // CTA
    mvvCtaTitle: "Join Our Mission",
    mvvCtaDesc: "Together, we can build a more inclusive Addis Ababa. Whether you're an individual with disabilities, an organization, or an ally, there's a place for you in our movement for change.",
    mvvCtaExplorePrograms: "Explore Programs",
    programs: "Programs",
    gallery: "Gallery",
    members: "Members",
    news: "News",
    contactUs: "Contact Us",
    resources: "Resources",
    donate: "Donate❤️",
    login: "Login",
    
    // Footer
    footerAboutBlurb: "A website dedicated to informing, supporting, and empowering persons with disabilities through accessible services, opportunities, and community engagement.",
    quickLinks: "Quick Links",
    fundedBy: "Funded By",
    zoaTagline: "ZOA - from relief to recovery",
    WaATagline: "We are Able",
    zoaFundedNote: "This website is funded by ZOA & We are Able.",
    rightsReserved: "All rights reserved.",
    
    // Hero Section
    heroTitle: "Addis Ababa Association of Persons with Disabilities",
    heroSubtitle: "A website dedicated to informing, supporting, and empowering persons with disabilities through accessible services, opportunities, and community engagement.",
    accessDashboard: "Join Our Network",
    learnMore: "Learn More",
    
    // About Section
    aboutMission: "About Our Mission",
    aboutTitle: "Advancing Rights, Removing Barriers",
    aboutDescription: "We are committed to ensuring persons with disabilities become equal participants and equitable beneficiaries in society. By raising awareness and providing tools, support, and opportunities, we empower individuals to exercise their social, economic, and political rights fully.",
    promoteAccess: "Promote Access & Inclusion",
    connectOPDs: "Connect OPDs & Partners",
    supportingMembers: "Supporting thousands of members in Addis Ababa.",
    buildingNetwork: "Building a powerful network for advocacy and care.",
    
    // AboutUsPage - Story/Timeline
    aboutBackgroundTitle: "Background",
    aboutBackgroundDesc: "The Addis Ababa Association of Persons with Disabilities (AAAPD) is an umbrella organization that brings together people with all types of disabilities, including physical, hearing, visual, intellectual, and psychosocial disabilities. The Association was established to address marginalization, promote inclusion, and advocate for equal rights and opportunities in the capital city.",
    umbrellaTitle: "Umbrella Disability Association for Addis Ababa",
    umbrellaText: "AAAPD is a city-wide umbrella association that brings together people with all types of disabilities—physical, hearing, visual, intellectual, and psychosocial. It was established to address marginalization, promote inclusion, and advocate for equal rights and opportunities in the capital city.",
    visionMissionTitle: "Vision & Mission",
    visionMissionText: "AAAPD envisions an inclusive, barrier-free Addis Ababa where all persons with disabilities enjoy equal rights, participation, and dignity. Its mission is to advocate, coordinate, and implement programs that empower persons with disabilities and improve access to education, health, employment, social services, and decision-making spaces at all levels.",
    coreObjectivesTitle: "Core Objectives",
    coreObjectivesText: "AAAPD works to promote the rights and interests of persons with disabilities, strengthen disability-inclusive development across all sectors, and facilitate economic empowerment through skills training and employment initiatives. The association also advocates for accessible infrastructure, information, and services, and mobilizes and coordinates sub-city disability associations and grassroots groups across Addis Ababa.",
    structureMembershipTitle: "Structure & Membership",
    structureMembershipText: "AAAPD operates with an Executive Committee led by a Chairperson and covers all 11 sub-cities of Addis Ababa through sub-city and woreda-level structures. Membership includes individual persons with diverse disabilities as well as disability-led organizations. The association is intentionally inclusive of women, youth, and cross-disability groups in its leadership and representation.",
    keyProgramAreasTitle: "Key Program Areas",
    keyProgramAreasText: "The association engages in advocacy and policy influence, disability rights awareness and legal protection, capacity-building and leadership development, livelihood and skills training, and promoting inclusive education and health services. AAAPD also focuses on accessibility and social protection, as well as community mobilization and partnership-building to sustain inclusive change.",
    partnershipsTitle: "Partnerships & Target Groups",
    partnershipsText: "AAAPD collaborates with key government offices such as Labour & Social Affairs, Women & Social Protection, Education, and Health, as well as with civil society organizations, NGOs, DPO networks, international partners, and community-based associations. Its target groups include persons with physical, visual, hearing, intellectual and other disabilities, women and youth with disabilities, parents and caregivers of children with disabilities, and sub-city disability leaders and grassroots members.",
    guidingPrinciplesTitle: "Guiding Principles & Future Direction",
    guidingPrinciplesText: "Guided by the principles of inclusion, equality and non-discrimination, participation, accessibility, and accountability and transparency, AAAPD continues to strengthen its role as a leading disability movement in Addis Ababa. The association seeks to deepen its impact by expanding inclusive programs, strengthening systems, and ensuring that persons with disabilities are fully represented in all aspects of social, economic, and political life.",
    aboutTaglineTitle: "Breaking Barriers. Empowering Ability. Transforming Lives.",
    aboutTaglineSub: "Breaking barriers, empowering ability, transforming lives.",

    // Partners Section (About)
    partnersHeading: "Our Partners",
    partnersIntro: "We collaborate with leading organizations and institutions to amplify our impact and create lasting change for persons with disabilities in Addis Ababa.",
    partnerZOATitle: "ZOA",
    partnerZOADesc: "A dedicated partner in disability advocacy and community development initiatives across Addis Ababa.",
    partnerWAATitle: "We Are Able",
    partnerWAADesc: "Empowering persons with disabilities through innovative programs and inclusive community building.",
    partnerDPOTitle: "DPO Networks",
    partnerDPODesc: "Strengthening disability-led organizations to amplify collective voice, leadership, and grassroots impact.",
    partnerInternationalTitle: "International Partners",
    partnerInternationalDesc: "Collaborating on sustainable development initiatives that expand economic opportunity and social inclusion.",
    partnerCSOTitle: "Civil Society Organizations",
    partnerCSODesc: "Partnering to deliver community-driven solutions that promote equity, participation, and social change.",
    partnerGovTitle: "Government Offices (Labour & Social Affairs, Women & Social Protection, Education, Health)",
    partnerGovDesc: "Working with public institutions to advance inclusive policies, accessible services, and systemic impact across sectors.",

    // PublicMembersPage
    publicMembersHeroSubtitle: "Join a vibrant community of persons with disabilities making a difference across Addis Ababa.",
    publicMembersPartnersTitle: "Our Partner Organizations",
    publicMembersPartnersDesc: "Proudly partnered with leading disability rights organizations across Addis Ababa, working together to create positive change.",
    publicMembersWhyJoin: "Why Join Us?",
    publicMembersBenefitsTitle: "Membership Benefits",
    publicMembersBenefitsDesc: "Unlock a world of opportunities, support, and growth when you become part of our community.",
    publicMembersBenefit1Title: "Supportive Community",
    publicMembersBenefit1Desc: "Connect with peers who understand your journey and provide mutual support and encouragement.",
    publicMembersBenefit2Title: "Exclusive Programs",
    publicMembersBenefit2Desc: "Access specialized training, education, and development programs designed for your needs.",
    publicMembersBenefit3Title: "Professional Network",
    publicMembersBenefit3Desc: "Build connections with mentors, employers, and organizations in your field of interest.",
    publicMembersBenefit4Title: "Advocacy Platform",
    publicMembersBenefit4Desc: "Have your voice heard in policy discussions and disability rights advocacy efforts.",
    publicMembersCtaTitle: "Ready to Join Our Community?",
    publicMembersCtaDesc: "Take the first step towards empowerment, support, and making a difference.",

    // Call to Partnership (About)
    callPartnershipTitle: "Interested in Partnership?",
    callPartnershipDesc: "Join us in creating an inclusive Addis Ababa. We welcome partnerships with organizations, businesses, and individuals committed to disability rights and inclusion.",
    callPartnershipCta: "Get in Touch",
    
    // Features Section
    featuresTitle: "Our Objectives",
    featuresSubtitle: "Everything you need to know and understand about our Objectives.",
    featuresTitle2: "Discover Our Impact",
    featuresTitle3: "Watch how we're making a difference in the lives of persons with disabilities across Ethiopia",
    featuresTitle4: "Learn more about our programs and the communities we serve",
    memberManagement: "Promote the rights and interests of persons with disabilities.",
    memberManagementDesc: "Uphold human rights and ensure respect, dignity, and equal treatment, while advancing full inclusion in social, economic, political, and community life.",
    supportTrackings: "Strengthen disability-inclusive development across all sectors.",
    supportTrackingDesc: "Promote accurate understanding of disability, expand inclusive policies and services, and ensure that development efforts at every level address the needs and capabilities of persons with disabilities.",
    secureCommunication: "Facilitate economic empowerment through skills training and employment initiatives.",
    secureCommunicationDesc: "Create pathways for meaningful employment through vocational training, digital skills development, entrepreneurship support, and job placement opportunities.",
    dataReporting: "Advocate for accessible infrastructure, information, and services.",
    dataReportingDesc: "Support the development and improvement of physical, digital, and communication accessibility—including assistive devices, technologies, and essential services—to enhance independence and full participation.",
    dataReporting2: "Mobilize and coordinate sub-city disability associations and grassroots groups.",
    dataReportingDesc2: "Strengthen organized disability networks by supporting collaboration, leadership, and collective action across OPDs, community groups, and grassroots structures.",
    dataReporting3: "Partner with government, NGOs, and international bodies on disability inclusion.",
    dataReportingDesc3: "Build strong, coordinated partnerships to advance inclusive governance, peacebuilding, program implementation, and rights-based disability initiatives.",
    
    // Social Proof Section
    trustedTitle: "Trusted by Organizations Nationwide",
    trustedSubtitle: "We are proud to partner with OPDs to drive meaningful change.",
    opdsPartnered: "OPDs Members",
    membersSupported: "Members Reached",
    projectsImplemented: " Government & NGO Partnerships",
    offlineFirst: "Offline-First",
    reliableAccessible: "Reliable & Accessible",
    
    // Testimonials Section
    testimonial: "Testimonial",
    testimonialsTitle: "What People Say About Our Work",
    trustedPartners: "Trusted by more than",
    partners: "partners",
    allTestimonials: "All Testimonials",
    testimonial1: "After my accident, I felt forgotten. AAAPD's counseling and empowerment programs helped me rebuild my confidence and guide others.",
    testimonial1Name: "Meron Mekuriya",
    testimonial1Title: "Peer Mentor",
    testimonial2: "Accessibility used to be a challenge in my area, but thanks to AAAPD, our local center is now open to everyone — wheelchair users included.",
    testimonial2Name: "Rahel Bekele",
    testimonial2Title: "Community Advocate",
    testimonial3: "The leadership workshops inspired me to speak up for inclusion. I now lead youth initiatives that promote equality and accessibility.",
    testimonial3Name: "Mekonnen Tesfaye",
    testimonial3Title: "Youth Participant",
    
    // News Section
    newsTitle: "Latest News & Updates",
    newsSubtitle: "Stay informed about our latest activities and impact.",
    news1Title: "New Partnership to Expand Digital Literacy",
    news1Desc: "We've partnered with Tech for All to provide digital skills training to over 500 members.",
    news2Title: "Annual General Meeting Highlights Key Achievements",
    news2Desc: "Our 2024 AGM celebrated a year of growth, with a 20% increase in member support.",
    news3Title: "Launch of Offline-First Mobile App",
    news3Desc: "Our new mobile app ensures members can access resources even without an internet connection.",
    readMore: "Read More",
    
    // NewsPage Section
    newsPageTitle: "Latest News",
    newsPageSubtitle: "Stay updated with the latest developments, success stories, and announcements from our community.",
    featuredLabel: "Featured",
    breakingNews: "Breaking News",
    recentUpdates: "Recent Updates",
    recentUpdatesDesc: "Catch up on the latest happenings in our community.",
    readFullStory: "Read Full Story",
    stayInformed: "Stay Informed",
    stayInformedDesc: "Subscribe to our newsletter to receive the latest news and updates directly in your inbox.",
    subscribeNow: "Reach Us Now",
    // NewsPage additions
    newsSource: "News source",
    disabilityNewsPill: "Disability News",
    disabilityHeadlinesTitle: "Global & Ethiopian Disability Headlines",
    disabilityHeadlinesDesc: "Live updates on disability rights, inclusion, policy reforms, and accessibility—focusing on Ethiopia and worldwide developments.",
    ethiopiaFocusLabel: "Ethiopia Focus",
    globalPerspectiveLabel: "Global Perspective",
    ethiopiaSectionTitle: "Ethiopia – Persons with Disabilities",
    ethiopiaEmpty: "No recent Ethiopia-specific disability news found at the moment.",
    globalHighlightsTitle: "Global Disability Highlights",
    globalEmpty: "No recent global disability news found at the moment.",
    ethiopiaCategoryLabel: "Ethiopia / Disability",
    newsQuoteBanner: "By strengthening advocacy through AAAPD and its 11 OPDs, Addis Ababa can advance the rights, dignity, and well-being of persons with disabilities and build a more inclusive and equitable city for all.",
    advocacyPolicyTitle: "AAAPD Advocacy & Policy",
    advocacyAwarenessTitle: "Awareness campaigns",
    advocacyAwarenessDesc: "AAAPD and its 11 OPDs lead public campaigns across Addis Ababa to educate communities on disability rights, challenge stereotypes, and promote inclusion.",
    advocacyPolicyEngTitle: "Policy engagement",
    advocacyPolicyEngDesc: "Advocate for disability-inclusive policies at city and sub-city levels—covering education, employment, healthcare, accessibility, and social protection.",
    advocacyMediaTitle: "Community & media engagement",
    advocacyMediaDesc: "Share member stories, program results, and best practices to amplify OPD voices and strengthen AAAPD’s public presence.",
    advocacyImageAlt: "AAAPD workshop",
    advocacyImageSr: "AAAPD advocacy workshop",
    inclusivenessTitle: "Inclusiveness & Capacity Building for OPDs",
    inclusivenessTrainingTitle: "OPD staff training",
    inclusivenessTrainingDesc: "Practical training for data clerks, leaders, and case workers on registration, support tracking, reporting, and communication.",
    inclusivenessNetworkTitle: "Network & coordination",
    inclusivenessNetworkDesc: "Strengthen coordination among OPDs, AAAPD, and stakeholders to align priorities and share resources.",
    inclusivenessMonitoringTitle: "Monitoring & accountability",
    inclusivenessMonitoringDesc: "Track commitments and outcomes; generate transparent reports that hold institutions accountable to disability rights.",
    inclusivenessLegalTitle: "Legal referral & case support",
    inclusivenessLegalDesc: "Connect members to legal assistance and rights-based services; leverage CRPD mechanisms where relevant.",
    miniLinkageTitle: "OPD–partner linkage",
    miniLinkageDesc: "Engage Partners; participate in national and international forums.",
    miniEvidenceTitle: "Evidence & reporting",
    miniEvidenceDesc: "Consolidate OPD data and publish accessible reports for donors and stakeholders.",
    miniDataTitle: "Data-driven planning",
    miniDataDesc: "Use analytics to prioritize cases, allocate resources, and demonstrate impact.",
    miniResourceTitle: "Resource mobilization",
    miniResourceDesc: "Strong visibility and credible data attract funding and long-term partnerships.",
    
    // AssociationDashboard (EN)
    assocDashboardTitle: "Addis Ababa Association of Persons with Disabilities Dashboard",
    assocDashboardWelcome: "Welcome back, here's an overview of the association's activities.",
    latestDisNews: "Latest Disability News",
    searchPlaceholder: "Search keyword...",
    localNews: "Local News",
    ethiopiaNews: "Ethiopia News",
    worldwideNews: "Worldwide News",
    search: "Search",
    loadingNews: "Loading news...",
    noLocalNewsFound: "No local news found.",
    noNewsFound: "No news found for this keyword/country.",
    couldNotLoadNews: "Could not load news at this time.",
    numberOfMembers: "Number of Members",
    unknownSource: "Unknown Source",
    aaapdNewsSource: "AAAPD News",
    externalNewsCategory: "External News",
    newsCategory: "News",
    totalOpds: "Total OPDs",
    totalMembers: "Total Members",
    averageAge: "Average Age",
    genderSplit: "Gender Split",
    membersByDisability: "Members by Disability Type",
    membersByGender: "Members by Gender",
    close: "Close",
    // Disability and gender labels
    disTypeVisual: "Visual impairment",
    disTypeHearing: "Hearing impairment",
    disTypePhysical: "Physical/Mobility impairment",
    disTypeIntellectual: "Intellectual disability",
    disTypeMentalHealth: "Mental health condition",
    disTypeChronicIllness: "Chronic illness",
    disTypeSpeech: "Speech impairment",
    disTypeOther: "Other",
    male: "Male",
    female: "Female",
    noDescription: "No description available.",

    // DisabilityPoliciesResearchPage
    policiesViewDocument: "View document",
    policiesDownloadPdf: "Download PDF",
    policiesHeroPill: "Disability Policies & Research Hub",
    policiesHeroTitlePrefix: "Evidence, laws and tools for",
    policiesHeroTitleHighlight: "disability inclusion",
    policiesHeroDesc: "This page brings together key national policies, international conventions, research, reports and practical toolkits on the rights of persons with disabilities. It supports AAAPD, member OPDs, government offices and partners to plan, advocate and implement disability-inclusive programmes.",
    policiesQuickOverview: "Quick overview",
    policiesQuickOverviewDesc: "Policies, conventions, research, reports & toolkits",
    policiesBullet1: "National Ethiopian disability laws and strategies",
    policiesBullet2: "UN CRPD, African Disability Protocol and SDGs",
    policiesBullet3: "Key research and country studies on disability",
    policiesBullet4: "Practical tools for OPDs, NGOs and government",
    policiesNationalTitle: "National Disability Policies & Laws (Ethiopia)",
    policiesNationalSubtitle: "Key national frameworks that guide disability rights, inclusion and services across sectors.",
    policiesInternationalTitle: "International & Regional Frameworks",
    policiesInternationalSubtitle: "Global and African human rights instruments that Ethiopia has committed to – and that OPDs can use for advocacy.",
    policiesResearchTitle: "Research & Evidence on Disability",
    policiesResearchSubtitle: "Selected global and country-level studies that provide data, analysis and recommendations for disability-inclusive policies.",
    policiesReportsTitle: "Government & Partner Reports",
    policiesReportsSubtitle: "Templates and examples to help AAAPD and OPDs report on disability inclusion, accessibility and advocacy results.",
    policiesToolkitsTitle: "Toolkits & Practical Guidelines",
    policiesToolkitsSubtitle: "Ready-to-use tools and guides for programme design, community work, inclusive education and rights-based advocacy.",
    
    // DonationPage
    donationHeroTitle: "Support Our Mission — Empower Lives",
    donationHeroDesc1: "Together, we can break barriers, promote inclusion, and empower persons with disabilities in Addis Ababa and beyond.",
    donateNow: "Donate Now",
    whyDonateTitle: "Why Donate?",
    whyDonateDesc: "Your support enables the Addis Ababa Disability Association (የአዲስ አበባ አካል ጉዳተኞች ማህበር) to make a real difference in the lives of persons with disabilities.",
    donateImpact1Title: "Advocate for Disability Rights",
    donateImpact1Desc: "Support policy advocacy and legislative consultation to advance the rights of persons with disabilities.",
    donateImpact2Title: "Sign Language Training",
    donateImpact2Desc: "Fund workshops and training programs for Ethiopian Sign Language educators and interpreters.",
    donateImpact3Title: "Accessibility Projects",
    donateImpact3Desc: "Improve accessibility in public spaces and promote inclusive infrastructure development.",
    donateImpact4Title: "Community Empowerment",
    donateImpact4Desc: "Strengthen disability networks and support community engagement initiatives.",
    donateImpact5Title: "Awareness Campaigns",
    donateImpact5Desc: "Fund educational campaigns that promote understanding and inclusion of persons with disabilities.",
    contributionMattersTitle: "Your Contribution Matters",
    contributionMattersDesc: "Your contribution is an investment in a more inclusive Addis Ababa. Every donation counts.",
    howToDonateTitle: "How to Donate",
    howToDonateDesc: "We make donating easy and secure.",
    bankTransferTitle: "Bank Transfer",
    cbeBankLabel: "CBE (Commercial Bank of Ethiopia)",
    accountNameLabel: "Account Name:",
    accountNumberLabel: "Account Number:",
    swiftCodeLabel: "Swift Code:",
    thankYouTitle: "Thank You for Your Support",
    thankYouDesc: "Your generosity helps us continue our vital work in promoting disability rights, accessibility, and inclusion throughout Addis Ababa. Every contribution brings us closer to our vision of a barrier-free city for all.",
    
    // AnnualReportPage
    annualReportHeroTitle: "AAAPD's Annual Report",
    annualReportTitlePrefix: "AAAPD Annual Report",
    annualReportLivePreview: "Report Live Preview",
    annualReportLivePreviewDesc: "Preview the full annual report directly in your browser. Use the controls to navigate, zoom, and explore our comprehensive review of the year's achievements and impact.",
    annualReportIntro1: "In our Annual Report 2024, we present the impact of our work on the lives of more than 2.1 million people.",
    annualReportIntro2: "Despite global challenges and reduced funding, the needs of persons with disabilities and vulnerable groups continued to grow in 2024.",
    annualReportIntro3: "Through advocacy, community engagement, and empowerment programs, AAAPD has contributed to real, positive change in Addis Ababa and beyond.",
    annualReportIntro4: "Our Annual Report highlights these achievements and outlines our vision for a fully inclusive future.",
    annualReportDownloadPrefix: "Download AAAPD's Annual Report",
    annualReportDownloadSuffix: "(PDF)",
    annualReportDownloadsTitle: "Downloads — AAAPD's Previous Reports",
    annualReportDownloadsDesc: "Access our comprehensive annual reports from previous years to understand our journey and continued commitment to disability rights and inclusion.",
    annualReportNoPrevious: "No previous reports available.",
    annualReportCardTitle: "Annual Report",
    reportLabel: "Report",
    downloadPdf: "Download PDF",
    // PDF viewer strings
    searchInPdf: "Search in PDF",
    sharePdf: "Share PDF",
    exitFullscreen: "Exit Fullscreen",
    enterFullscreen: "Enter Fullscreen",
    searchInPdfPlaceholder: "Search in PDF...",
    searchButton: "Search",
    searchFoundPrefix: "Found",
    searchResultsPlural: "results",
    searchResultsSingular: "result",
    searchFor: "for",
    pageLabel: "Page",
    matchesPlural: "matches",
    matchesSingular: "match",
    clickToView: "Click to view",
    andPrefix: "and",
    moreResultsSuffix: "more results",
    noResultsFound: "No results found for",
    tryDifferentKeywords: "Try different keywords or check spelling",
    annualReportFallbackTitle: "Annual Report",
    annualReportInteractivePreview: "Interactive PDF Preview",
    annualReportUnsupportedMessage: "Your browser doesn't support PDF previews.",
    annualReportViewDirectLink: "Click here to view the PDF directly",
    
    // Home CTA Section (Join Our Community)
    homeCtaTitle: "Join Our Community",
    homeCtaDesc: "Register as a person with disability and connect with local OPDs for support, resources, and community engagement.",
    homeCtaButton: "Register Now",
    
    // News Articles
    featuredNewsTitle: "New Accessibility Initiative Launched Nationwide",
    featuredNewsExcerpt: "We are excited to announce the launch of our comprehensive accessibility initiative that will benefit thousands of persons with disabilities across the country. This groundbreaking program focuses on improving infrastructure, education, and employment opportunities.",
    featuredNewsDate: "December 15, 2024",
    featuredNewsAuthor: "Communications Team",
    featuredNewsCategory: "Announcement",
    
    news1Title: "Successful Completion of Vocational Training Program",
    news1Excerpt: "Over 200 participants graduated from our latest vocational training program, with 85% securing employment within three months of completion.",
    news1Date: "December 10, 2024",
    news1Author: "Program Director",
    news1Category: "Success Story",
    
    news2Title: "Partnership with Local Universities Announced",
    news2Excerpt: "We have formed strategic partnerships with five leading universities to provide scholarship opportunities and inclusive education programs.",
    news2Date: "December 5, 2024",
    news2Author: "Education Team",
    news2Category: "Partnership",
    
    news3Title: "Annual Conference 2024: Building Inclusive Communities",
    news3Excerpt: "Join us for our annual conference featuring keynote speakers, workshops, and networking opportunities focused on building more inclusive communities.",
    news3Date: "November 28, 2024",
    news3Author: "Event Coordinator",
    news3Category: "Event",
    
    news4Title: "New Healthcare Support Program Launched",
    news4Excerpt: "Our new healthcare support program provides free medical consultations and assistive devices to members in need.",
    news4Date: "November 20, 2024",
    news4Author: "Healthcare Team",
    news4Category: "Program Launch",
    
    news5Title: "Advocacy Campaign Achieves Policy Changes",
    news5Excerpt: "Our recent advocacy efforts have resulted in significant policy changes that will improve accessibility in public transportation.",
    news5Date: "November 15, 2024",
    news5Author: "Advocacy Team",
    news5Category: "Advocacy",
    
    news6Title: "Community Outreach Program Expands to Rural Areas",
    news6Excerpt: "We are expanding our community outreach program to reach underserved rural communities, bringing essential services closer to those who need them most.",
    news6Date: "November 10, 2024",
    news6Author: "Outreach Coordinator",
    news6Category: "Expansion",
    
    // ProgramsPage Section
    programsPageTitle: "Our Programs",
    programsPageSubtitle: "Discover the initiatives we've designed to empower, support, and uplift persons with disabilities in our community.",
    programsBrowseByCategory: "Browse Programs by Category",
    programsClickCategoryToFilter: "Click on a category to filter programs",
    programsSearchPlaceholder: "Search programs...",
    programsAll: "All",
    programsEmptyTitle: "No programs found",
    programsEmptyDesc: "Try adjusting your search or filter criteria",
    programsTaglineTitle: "Building an Inclusive Future Together",
    programsTaglineSub: "Our programs are designed to create lasting impact and empower individuals with disabilities to reach their full potential",
    programsImpactLabel: "Impact",
    descriptionLabel: "Description",
    programsKeyActivitiesLabel: "Key Activities",
    closeButton: "Close",
    step1Title: "Step 1: Contact Us",
    contactUs: "Contact Us",
    programsStep2Desc: "Schedule an initial consultation with our team",
    programsGetStartedTitle: "Ready to Get Started?",
    programsGetStartedDesc: "Join our community and discover how our programs can support you",
    programsStartJourney: "Start Your Journey",
    whatWeOffer: "What We Offer",
    whatWeOfferDesc: "Our programs are tailored to meet the diverse needs of our members.",
    learnMore: "Learn More",
    
    // Programs
    educationTitle: "Education & Scholarships",
    educationDesc: "Providing access to quality education and scholarship opportunities for students with disabilities to help them achieve their academic goals.",
    
    employmentTitle: "Vocational Training & Employment",
    employmentDesc: "Equipping individuals with practical skills and connecting them with inclusive employers to foster financial independence.",
    
    healthcareTitle: "Healthcare & Rehabilitation",
    healthcareDesc: "Offering essential healthcare services, assistive devices, and rehabilitation programs to improve quality of life.",
    
    advocacyTitle: "Advocacy & Awareness",
    advocacyDesc: "Championing the rights of persons with disabilities and running campaigns to promote a more inclusive and accessible society.",
    
    communityTitle: "Community Building Events",
    communityDesc: "Organizing social and recreational events to foster a sense of community, reduce isolation, and build supportive networks.",
    
    // How to Participate Section
    getInvolved: "Get Involved",
    howToAccess: "How to Access Our Programs",
    howToAccessDesc: "Becoming a part of our programs is simple. Follow these steps to get started on your journey with us.",
    
    step1Title: "1. Become a Member",
    step1Desc: "Register with your local OPD to become an official member and get access to our network.",
    
    step2Title: "2. Needs Assessment",
    step2Desc: "Our team will work with you to understand your specific needs and goals.",
    
    step3Title: "3. Program Enrollment",
    step3Desc: "We will guide you through the enrollment process for the programs that best fit your needs.",
    
    // Programs Flow Section
    programsFlowTitle: "How Our Programs Work",
    programsFlow1Title: "Identify Needs",
    programsFlow1Desc: "We work closely with the community to identify the most pressing needs and challenges.",
    programsFlow2Title: "Develop Solutions",
    programsFlow2Desc: "Our team designs targeted programs to address identified needs with measurable outcomes.",
    programsFlow3Title: "Implement Programs",
    programsFlow3Desc: "We execute programs with the active participation of community members and partners.",
    programsFlow4Title: "Evaluate Impact",
    programsFlow4Desc: "Regular assessments ensure our programs deliver meaningful, lasting change.",

    programsAccessInclusionTitle: "Accessibility & Inclusion",
    programsAccessItem1Title: "Physical Accessibility",
    programsAccessItem1Desc: "All our facilities and events are designed to be fully accessible to individuals with various disabilities.",
    programsAccessItem2Title: "Communication Support",
    programsAccessItem2Desc: "We provide sign language interpreters and materials in accessible formats upon request.",
    programsAccessItem3Title: "Inclusive Design",
    programsAccessItem3Desc: "Our programs are developed with universal design principles to serve everyone effectively.",
    programsAccessItem4Title: "Personalized Assistance",
    programsAccessItem4Desc: "Individual accommodations are available to ensure full participation for all members.",

    // CTA Section
    programsCTATitle: "Have Questions or Want to Partner with Us?",
    programsCTADesc: "We are always looking for partners and volunteers to help us expand our reach and impact. Contact us to learn how you can contribute.",
    
    // FloatingSelfRegisterForm Section
    selfRegisterHere: "Self Register Here",
    selfRegistrationForm: "Self-Registration Form",
    selfRegistrationDesc: "Register yourself to access support services.",
    personalInformation: "Personal Information",
    disabilityInformation: "Disability Information",
    selectDisabilityType: "Select Disability Type",
    addDisabilityType: "Add Disability Type",
    disabilityDescription: "Disability Description",
    fullName: "Full Name",
    fullNamePlaceholder: "Enter your full name",
    gender: "Gender",
    male: "Male",
    female: "Female",
    age: "Age",
    agePlaceholder: "Enter your age",
    phoneNumber: "Phone Number",
    phoneNumberPlaceholder: "Enter your phone number",
    disabilityType: "Disability Type",
    idAttachment: "ID Attachment",
    idAttachmentPlaceholder: "Upload your ID document",
    
    // Disability Types
    visualImpairment: "Visual impairment",
    hearingImpairment: "Hearing impairment",
    mobilityImpairment: "Mobility impairment",
    intellectualDisability: "Intellectual disability",
    mentalHealthCondition: "Mental health condition",
    chronicIllness: "Chronic illness",
    speechImpairment: "Speech impairment",
    other: "Other",
    
    // Address Information
    addressInformation: "Address Information",
    city: "City",
    cityPlaceholder: "Enter your city",
    subcity: "Subcity",
    wereda: "Wereda",
    weredaPlaceholder: "Enter your wereda",
    kebele: "Kebele",
    kebelePlaceholder: "Enter your kebele",
    houseNumber: "House Number",
    houseNumberPlaceholder: "Enter your house number",
    
    // Additional Information
    additionalInformation: "Additional Information",
    messageDescription: "Message Description (Optional)",
    messagePlaceholder: "Tell us about your specific needs or any additional information...",
    
    // Form Actions
    cancel: "Cancel",
    submitRegistration: "Submit Registration",
    submitting: "Submitting...",
    
    // Success/Error Messages
    registrationSuccessful: "Registration Successful!",
    registrationSuccessDesc: "Your information has been submitted to the OPD.",
    registrationFailed: "Registration Failed",
    
    // Validation Messages
    fullNameRequired: "Full name is required",
    validAgeRequired: "Valid age is required",
    phoneNumberRequired: "Phone number is required",
    cityRequired: "City is required",
    weredaRequired: "Wereda is required",
    kebeleRequired: "Kebele is required",
    houseNumberRequired: "House number is required",
    noOPDFound: "No OPD found for the selected subcity.",
    submitFormFailed: "Failed to submit form. Please try again.",
    
    // Gallery Section
    galleryTitle: "Moments & Milestones",
    gallerySubtitle: "A glimpse into our community and the work we do.",
    viewMore: "View More",
    // GalleryPage specific
    galleryPageTitle: "Our Gallery",
    galleryEmptyTitle: "No images found",
    galleryEmptyDesc: "The gallery is currently empty. Please check back later for new images.",
    galleryReadMore: "Read more",
    galleryShowLess: "Show less",
    galleryImageFallback: "Gallery Image",
    enlargedViewAlt: "Enlarged view",
    
    // Contact Section
    contactTitle: "Get in Touch",
    contactSubtitle: "Have questions or want to partner with us? Drop a message below.",
    contactMapTitle: "Find Us on the Map",
    contactMapSubtitle: "AAAPD headquarters and partner OPDs across Addis Ababa.",
    livesImpacted: "Lives Impacted Annually",
    yourName: "Your Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    typeMessage: "Type Your Message",
    sendMessage: "Send a Message",
    officeHours: "Office Hours",
    mondayToFriday: "Monday - Friday",
    saturday: "Saturday",
    sunday: "Sunday",

    // Login Page
    loginTitle: "Sign in to your account",
    emailLabel: "Email",
    passwordLabel: "Password",
    rememberMe: "Remember me",
    forgotPassword: "Forgot password?",
    loggingIn: "Logging in...",
    loginButton: "Login",
    loginFailed: "Login failed",
    networkOrServerError: "Network or server error",
    
    // Forgot Password Page
    fpTitleRequest: "Reset your password",
    fpTitleVerify: "Enter verification code",
    fpSubtitleRequest: "Enter your email address and we'll send you a verification code.",
    fpSubtitleVerify: "Check your email for the code, then set a new password.",
    fpEnterEmail: "Please enter your email address",
    fpIfAccountExists: "If an account exists, a reset code has been sent to your email.",
    fpRequestFailed: "Failed to request password reset",
    fpEnterCode: "Please enter the verification code sent to your email.",
    fpPasswordMin: "Password must be at least 8 characters long.",
    fpPasswordsMismatch: "Passwords do not match.",
    fpResetSuccess: "Password has been reset successfully. Please sign in.",
    fpResetFailed: "Failed to reset password.",
    fpSending: "Sending...",
    fpSendCode: "Send code",
    fpVerificationCode: "Verification Code",
    fpCodePlaceholder: "Enter the code sent to your email",
    fpNewPassword: "New Password",
    fpPasswordPlaceholder: "At least 8 characters",
    fpConfirmPassword: "Confirm Password",
    back: "Back",
    fpResetting: "Resetting...",
    fpResetPassword: "Reset Password",
    fpRememberPassword: "Remember your password?",
    fpBackToSignIn: "Back to sign in",
    closed: "Closed",
    whatsapp: "WhatsApp",
    twitter: "Twitter",
    telegram: "Telegram",
    followUs: "Follow Us",
    
    // Accessibility Controls
    accHideControlsAria: "Hide accessibility controls",
    accShowControlsAria: "Show accessibility controls",
    accPanelTitle: "Accessibility Controls",
    accCloseAria: "Close accessibility controls",
    accScreenReader: "Screen Reader",
    accScreenReaderDisableAria: "Disable screen reader",
    accScreenReaderEnableAria: "Enable screen reader",
    accReading: "Reading… (click to re-read)",
    accReadThisPage: "Read this page",
    accVoiceCommands: "Voice Commands",
    accVoiceDisableAria: "Disable voice commands",
    accVoiceEnableAria: "Enable voice commands",
    accListening: "Listening…",
    accStartVoice: "Start voice command",
    accVoiceSettings: "Voice Settings",
    accVoiceType: "Voice Type",
    accVoiceDefault: "Default Voice",
    accVoiceFemale: "Female Voice",
    accVoiceMale: "Male Voice",
    accVoiceSlow: "Slow Speech",
    accVoiceFast: "Fast Speech",
    accContrastMode: "Contrast Mode",
    accHighContrast: "High Contrast",
    accDefaultContrast: "Default",
    accTextSize: "Text Size",
    accSmallTextAria: "Small text size",
    accDefaultTextAria: "Default text size",
    accLargeTextAria: "Large text size",
    accExamplesTitle: "Example voice commands:",
    accExReadPage: "\"Read this page\"",
    accExGoHome: "\"Go to home\"",
    accExGoWhoWeAre: "\"Go to who we are\"",
    accExOpenPrograms: "\"Open programs\"",
    accExOpenGallery: "\"Open gallery\"",
    accExGoContact: "\"Go to contact\"",
    accExIncreaseDecreaseText: "\"Increase text size\" / \"Decrease text size\"",
    accExHighNormalContrast: "\"High contrast\" / \"Normal contrast\"",
    accExScroll: "\"Scroll down\" / \"Scroll up\"",
    
    // Donor Impact Section
    donorImpactTitle: "Your Impact Makes a Difference",
    donorImpactSubtitle: "Every donation creates ripples of positive change in the lives of persons with disabilities across Addis Ababa. Here's how your generosity transforms communities and empowers individuals.",
    donorImpactHighlight1: "Providing Essential Mobility Aids",
    donorImpactHighlight1Desc: "Your contributions help provide wheelchairs, crutches, and other mobility devices, giving individuals with disabilities the freedom to move independently and participate fully in community life.",
    donorImpactHighlight2: "Expanding Accessibility in Public Spaces",
    donorImpactHighlight2Desc: "Support accessibility improvements in schools, hospitals, and public buildings, creating barrier-free environments where everyone can access essential services and opportunities.",
    donorImpactHighlight3: "Empowering OPDs Across Addis Ababa",
    donorImpactHighlight3Desc: "Strengthen Organizations of Persons with Disabilities (OPDs) with training, resources, and capacity-building programs that amplify their advocacy and service delivery.",
    donorImpactHighlight4: "Creating Job Opportunities",
    donorImpactHighlight4Desc: "Fund vocational training and employment programs that equip persons with disabilities with skills and connect them with inclusive employers, fostering financial independence.",
    donorImpactHighlight5: "Building Inclusive Communities",
    donorImpactHighlight5Desc: "Support community events, awareness campaigns, and social programs that reduce isolation, build supportive networks, and promote understanding among all community members.",
  },
  
  am: {
    // Navigation
    home: "ቤት",
    dashboard: "ዳሽቦርድ",
    members: "አባላት",
    messages: "መልዕክቶች",
    analysisAndReport: "ትንታኔ እና ሪፖርት",
    plansAndReports: "እቅዶች እና ሪፖርቶች",
    selfRegistered: "በራስ የተመዘገቡ",
    trash: "መጣያ ቅርጫት",
    supportTracking: "የድጋፍ ክትትል",
    supportReceived: "የተቀበለው ድጋፍ",
    management: "አስተዳደር",
    galleryManagement: "ጋሌሪ አስተዳደር",
    blogManagement: "ብሎግ አስተዳደር",
    programsManagement: "ፕሮግራሞች አስተዳደር",
    settings: "ቅንብሮች",
    profile: "መገለጫ",
    accessibility: "ተደራሽነት",
    logout: "ውጣ",
    logoutConfirmationTitle: "እርግጠኛ ነዎት መውጣት ይፈልጋሉ?",
    logoutConfirmationMessage: "ወደ መግቢያ ገጽ ይዛወራሉ።",
    cancel: "ሰርዝ",
    yesLogout: "አዎ፣ ውጣ",
    notifications: "ማሳወቂያዎች",
    noNewNotifications: "አዲስ ማሳወቂያ የለም",
    markAllAsRead: "ሁሉንም እንደተነበብ ምልክት አድርግ",
    viewAll: "ሁሉንም ተመልከት",
    viewMoreNotifications: "ተጨማሪ {count} ማሳወቂያዎችን ይመልከቱ",
    
    // Admin Navigation
    allMembers: "ሁሉም አባላት",
    pendingMembers: "በመጠባበቅ ላይ ያሉ አባላት",
    rejectedMembers: "ውድቅ አባላት",
    renewals: "እድሳት",
    opds: "ኦፒዲዎች",
    allOpds: "ሁሉም ኦፒዲዎች",
    reports: "ሪፖርቶች",
    viewReports: "ሪፖርቶችን ይመልከቱ",
    management: "አስተዳደር",
    galleryManagement: "ጋሌሪ አስተዳደር",
    blogManagement: "ብሎግ አስተዳደር",
    messages: "መልዕክቶች",
    supportTracking: "የድጋፍ ክትትል",
    perMember: "በአባል",
    perOpd: "በኦፒዲ",
    noPendingRequests: "ምንም በጥበቃ ላይ ያሉ ጥያቄዎች የሉም",
    markAllAsRead: "ሁሉንም እንደተነበበ ምልክት አድርግ",
    onlineStatus: "መስመር ላይ",
    offlineStatus: "መስመር ውጭ",
    about: "ስለ እኛ",
    whoWeAre: "እኛ ማን ነን",
    leadership: "መመሪያ",
    Partnerss: "አጋሮች",
    annualreport: "ዓመታዊ ሪፖርት",
    missionVisionValues: "ተልዕኮ፣ ራዕይ እና እሴቶች",
    
    // LeadershipPage
    leadershipHeroTitle: "መመሪያ እና አስተዳደር",
    leadershipHeroSubtitle: "ሁሉን ያካተተ ማኅበረሰብ ለመፍጠር የአዲስ አበባ አካል ጉዳተኞች ማኅበር ተልዕኮን የሚመራውን ቁርጠኛ አመራር ይወቁ።",
    leadershipIntroTitle: "መመሪያ እና አስተዳደር",
    leadershipIntroDesc: "የአዲስ አበባ አካል ጉዳተኞች ማኅበር ዋነኛ መሠረት በምክክር (አድቮካሲ)፣ በማካተትና አቅምን በማጎልበት ዙሪያ የተሰማራ አመራር ነው። በዶ/ር ወይንሸት ግርማ አያንሳ (ፒኤችዲ) የሚመራው ማኅበሩ፣ አካል ጉዳተኞች በክብር፣ በእኩልነትና ዕድል ባገኙበት ሙሉ በሙሉ ሁሉን ባካተተ ማኅበረሰብ ራዕይ ላይ በመመሥረት እየተጠናከረ ይገኛል።",
    leaderAboutWoinshetTitle: "ስለ ዶ/ር ወይንሸት ግርማ አያንሳ (ፒ.ኤች.ዲ.)",
    leaderWoinshetName: "ዶ/ር ወይንሸት ግርማ አያንሳ",
    leaderWoinshetTitle: "ፕሬዚዳንት፣ የአዲስ አበባ አካል ጉዳተኞች ማህበር",
    leaderWoinshetBio: "ዶ/ር ወይንሸት ግርማ አያንሳ (ፒኤችዲ) የተወለደችው የሚሰማ ቤተሰብ ውስጥ ቢሆንም፣ ከኢትዮጵያ የመጣች መስማት የተሳናት ሴት ነች። በአንደኛና ሁለተኛ ደረጃ ትምህርቷ ወቅት የምልክት ቋንቋ አስተርጓሚዎች እጥረት ቢኖርም፣ በአዲስ አበባ ዩኒቨርሲቲ የባችለር፣ የማስተርስ እና የዶክትሬት ዲግሪዎቿን ያጠናቀቀችው በቋንቋ ጥናት (ሊንጉስቲክስ) ሲሆን፣ በተለይም በምልክት ቋንቋ ጥናት (ሳይን ሊንጉስቲክስ) ላይ ትኩረት አድርጋለች። በኋላም በዩኒቨርሲቲው መምህር እና ለኢትዮጵያ መስማት የተሳናቸው ብሄራዊ ማህበር ብሔራዊ ፕሮጀክት አስተባባሪ በመሆን ሠርታለች። ወይንሸት ለመስማት የተሳናቸው መብት ተሟጋችነት ካላት ከፍተኛ ፍላጎት የተነሳ፣ ተስፋ ለመስማት የተሳናቸው ማኅበርን (Hope for the Deaf Association) መስርታለች፤ እዚያም የመስማት የተሳናቸውን መብትና ተጠቃሚነት ለማሳደግ የሚደረጉ ጥረቶችን በመምራት ዳይሬክተር ሆና እያገለገለች ነው። በአሁኑ ጊዜ በአገር አቀፍ ደረጃ ለአካል ጉዳተኞች መብት ተሟጋችነቷን በመቀጠል፣ የአዲስ አበባ አካል ጉዳተኞች ማኅበር ፕሬዝዳንት በመሆን እያገለገለች ትገኛለች።",
    leaderAchievement1: "ባለራዕይነት ያለው ተሟጋችነት፡ የምልክት ቋንቋ እውቅናን እና የፖሊሲ ለውጥን የሚያፋጥኑ ውጥኖችን መምራት",
    leaderAchievement2: "የማኅበረሰብ አቅም ማጎልበት፡ የአካል ጉዳተኞችን ድምፅ የሚያሰሙ ፕሮግራሞችን መፍጠር",
    leaderAchievement3: "ትብብር፡ ከመንግሥት፣ ከመንግሥታዊ ያልሆኑ ድርጅቶች (NGOs) እና ከአካባቢ ማኅበረሰቦች ጋር አጋርነት መፍጠር",
    leaderAchievement4: "ትምህርትና ግንዛቤ ማስጨበጥ፡ ስለ አካል ጉዳተኞች መብትና ተደራሽነት ዕውቀትና ግንዛቤን ማሳደግ",
    leaderQuote: "አካል ጉዳተኝነት ዕድልን የማይገድብባት ከተማ እናልማለን። አመራራችን በአዲስ አበባ የሚገኙ አካል ጉዳተኞች ሁሉ መሰናክሎችን ለመስበር፣ አቅምን ለማጎልበት እና ሕይወታቸውን ለመለወጥ ቁርጠኛ ነው።",
    leadershipAboutLabel: "ስለ",
    leadershipFocusLabel: "የአመራር ትኩረት",
    leadershipVisionTitle: "የአመራር ራዕይ",
    leadershipGovernanceTitle: "የአስተዳደር መዋቅር",
    leadershipGovernanceDesc: "ማህበራችን ግልጽነት፣ ተጠያቂነት እና ተሳትፎ ውሳኔ የሚያረጋግጥ የተዋቀረ መሪነት ተቋም በኩል ይነዳል።",
    leadershipOrgStructureTitle: "የድርጅት መዋቅር",
    leadershipPresident: "ፕሬዚዳንት",
    leadershipBoardOfDirectors: "የቦርድ አባላት",
    leadershipStrategicOversight: "ስትራቴጂ ክትትል",
    leadershipExecutiveCommittee: "ኤክዘኪውቲቭ ኮሚቴ",
    leadershipDailyManagement: "ዕለታዊ አስተዳደር",
    leadershipMemberAffairs: "የአባላት ጉዳይ ቅኝት",
    leadershipMembersOPDsGrassroots: "አባላት፣ OPDs እና መሠረታዊ ቡድኖች",
    leadershipGeneralManager: "ጠቅላላ ሥራ አስኪያጅ",
    leadershipDayToDayCoord: "ዕለታዊ ዝርዝር ቅኝት",
    leadershipVariousCommittees: "የቆይታ እና ጊዜያዊ ኮሚቴዎች",
    leadershipFinanceAdmin: "ፋይናንስ እና አስተዳደር አገልግሎት",
    leadershipCoordProjectPrintingIdentity: "የፕሮጀክት፣ ህትመት እና አታሚ ምርት ቅኝት",
    leadershipOffice: "ቢሮ",
    leadershipCentralBranches: "መሃል እና ቅርንጫፎች",
    leadershipBranchOffice: "የቅርንጫፍ ቢሮ",
    leadershipKeyResponsibilities: "ዋና ዋና ሃላፊነቶች:",
    leadershipMembersVaries: "ይለያያል",
    leadershipBoardDesc: "ከተልዕኮ ጋር ስምምነትን የሚያረጋግጥ እና ዋና ፖሊሲዎችን የሚያፀድቅ ስትራቴጂ ክትትል አካል።",
    leadershipExecDesc: "ዕለታዊ ስራዎችን የሚቀናበር እና የቦርድ መመሪያዎችን የሚፈጽም አካል።",
    leadershipMemberAffairsDesc: "የአባላት ግንኙነትን፣ OPD ተሳትፎን እና መሠረታዊ ግንኙነትን የሚመራ።",
    leadershipGeneralManagerDesc: "ዕለታዊ አስተዳደርን እና ክፍል መካከል ቅኝትን የሚመራ።",
    leadershipOfficeDesc: "የመሃል ቢሮ ተግባራት እና የቅርንጫፍ ቅኝት።",
    leadershipBranchOfficeDesc: "የማህበሩን አገልግሎት እና ተወካይነት ወደ አካባቢ ደረጃ የሚያስፋፍል።",
    leadershipStandingTemporaryCommittees: "የቆይታ እና ጊዜያዊ ኮሚቴዎች",
    leadershipStandingCommitteesDesc: "የርዕሰ ጉዳይ እና አድሆክ እርዳታ አካላት ልዩ ተነሳሽነቶችን ይደግፋሉ።",
    leadershipFinanceAdminDesc: "ፋይናንስ፣ ሰ/ሀ ሀይል፣ ግዢ እና አስተዳደርን ይተባበራሉ።",
    leadershipCoordPPIRespDesc: "ፕሮጀክቶችን፣ ህትመት እና ድርጅታዊ ምርትን ይቀናበራሉ።",
    leadershipRolePresidentTitle: "ፕሬዚዳንት / አብራሪ",
    leadershipRolePresidentDesc: "ስትራቴጂ መሪነት፣ የህዝብ ተወካይነት እና የጠቅላላ አስተዳደር አቅጣጫ ይሰጣል።",
    leadershipRolePresidentResp1: "ራዕይ መዘጋጀት እና ስትራቴጂ መሪነት",
    leadershipRolePresidentResp2: "የከፍተኛ ደረጃ ተወካይነት እና ተሟጋትነት",
    leadershipRolePresidentResp3: "የአስተዳደር ውጤታማነት ክትትል",
    leadershipRolePresidentResp4: "ለቦርድ እና ለኤክዘኪውቲቭ መመሪያ",
    leadershipBoardResp1: "ስትራቴጂ ክትትል እና መመሪያ",
    leadershipBoardResp2: "ፖሊሲ እድገት እና አፀድቃ",
    leadershipBoardResp3: "ሪስክ አስተዳደር እና መደመር",
    leadershipBoardResp4: "አፈፃፀም ክትትል",
    leadershipExecResp1: "የኦፕሬሽን ውሳኔ መስጠት",
    leadershipExecResp2: "ፕሮግራም አፈጻጸም እና ክትትል",
    leadershipExecResp3: "ሀብት ማሰባሰብ",
    leadershipExecResp4: "አብረን መስራት አስተዳደር",
    leadershipMemberResp1: "ከአባላት እና OPD ጋር ቅኝት",
    leadershipMemberResp2: "መሠረታዊ ተሳትፎ",
    leadershipMemberResp3: "መረጃ እና ግብረመልስ ሂደት",
    leadershipMemberResp4: "ከአካባቢ መዋቅር ጋር ግንኙነት",
    leadershipGMResp1: "ፕሮግራም እና ፕሮጀክት ቅኝት",
    leadershipGMResp2: "ሰራተኞች እና ኦፕሬሽን አስተዳደር",
    leadershipGMResp3: "አፈፃፀም ክትትል",
    leadershipGMResp4: "ለኤክዘኪውቲቭ/ቦርድ ሪፖርት",
    leadershipOfficeResp1: "አስተዳደራዊ አገልግሎቶች",
    leadershipOfficeResp2: "የቅርንጫፍ ቅኝት",
    leadershipOfficeResp3: "ሎጀስቲክስ እና የቢሮ ድጋፍ",
    leadershipOfficeResp4: "መዝገብ እና ሰነዶች",
    leadershipBranchResp1: "አካባቢ አገልግሎት አቅርቦት",
    leadershipBranchResp2: "የማህበረሰብ ግንኙነት",
    leadershipBranchResp3: "የአባላት ድጋፍ",
    leadershipBranchResp4: "ለቢሮ ሪፖርት",
    leadershipCommitteesResp1: "ልዩ ግብረሀብት መስጠት",
    leadershipCommitteesResp2: "የፕሮጀክት አፈፃፀምን ድጋፍ",
    leadershipCommitteesResp3: "ጊዜያዊ የተግባር ቡድኖች",
    leadershipCommitteesResp4: "ለጠቅላላ ሥራ አስኪያጅ ሪፖርት",
    leadershipFinanceResp1: "የፋይናንስ አስተዳደር",
    leadershipFinanceResp2: "ሰ/ሀ ሀይል እና ግዢ",
    leadershipFinanceResp3: "መደመር እና ቁጥጥር",
    leadershipFinanceResp4: "አስተዳደራዊ ድጋፍ",
    leadershipPPIResp1: "የፕሮጀክት ቅኝት",
    leadershipPPIResp2: "ህትመት እና ህትመቶች",
    leadershipPPIResp3: "ብራንድ እና ምርት",
    leadershipPPIResp4: "ሰነድ አስተዳደር",
    leadershipPrinciplesTitle: "የአስተዳደር መርሆዎች",
    leadershipPrinciplesHeadline: "ግልጽ መሪነት። ሁሉን አቀፍ ውሳኔ መስጠት።",
    leadershipPrinciplesSubAm: "ግልጽ መሪነት፣ አጠቃላይ ውሳኔ ማድረግ።",
    leadershipCtaTitle: "የመሪነት ጉዟችንን ይቀላቀሉ",
    leadershipCtaDesc: "አካታች አዲስ አበባን ለመፍጠር በምናደርገው እንቅስቃሴ ውስጥ ተሳታፊ ይሁኑ። የመሪነት ልምድ ቢኖርዎትም ወይም ክህሎትዎን ማዳበር ቢፈልጉ፤ ለአካል ጉዳተኞች መብት መከበር ቁርጠኛ የሆኑ ንቁ ግለሰቦችን በደስታ እንቀበላለን።",
    ourMissionButton: "የእኛ ተልዕኮ",
    // MissionVisionValuesPage (MVV)
    mvvHeroSubtitle: "አካል ጉዳተኞችን ለመደገፍ እና በአዲስ አበባ ሁሉን አቀፍ ማህበረሰብ ለመፍጠር ስላደረግነው ቁርጠኝነት ይወቁ።",
    // Mission
    mvvMissionTitle: "ተልዕኮ",
    mvvMissionDesc: "ተልዕኳችን በአዲስ አበባ ለሚገኙ አካል ጉዳተኞች ሰብዓዊ ክብር፣ እኩል መብት እና ሙሉ አካታችነት እንዲረጋገጥ መስራት ነው። አካል ጉዳተኝነት ለተሳትፎ እንቅፋት የማይሆንባት፣ ተደራሽ እና አካታች የሆነች ማህበረሰብ ለመፍጠር እንተጋለን።",
    mvvWeWorkTo: "እኛ የምንሰራው:",
    mvvMissionPoint1Title: "ለአካል ጉዳተኞች እኩል ተሳትፎን ማረጋገጥ",
    mvvMissionPoint1Desc: "አካል ጉዳተኞች ያለምንም እንቅፋት በማህበራዊ፣ ኢኮኖሚያዊ እና ፖለቲካዊ ህይወት ውስጥ ሙሉ በሙሉ እንዲሳተፉ ማካተትን ማሳደግ።",
    mvvMissionPoint2Title: "ፍትሃዊ ተደራሽነትን እና ተጠቃሚነትን ማረጋገጥ",
    mvvMissionPoint2Desc: "አካል ጉዳተኞች በሁሉም ዘርፎች እኩል የሆኑ ዕድሎችን፣ አገልግሎቶችን እና ግብዓቶችን እንዲያገኙ ለማረጋገጥ መስራት።",
    mvvMissionPoint3Title: "የመብቶች እና ግዴታዎች ግንዛቤን ማሳደግ",
    mvvMissionPoint3Desc: "ለአካል ጉዳተኞች ማህበራዊ፣ ኢኮኖሚያዊ እና ፖለቲካዊ መብቶች ግንዛቤን ለማጠናከር ትምህርት እና የማህበረሰብ ዘርፍ እንቅስቃሴዎችን መስጠት።",
    mvvMissionPoint4Title: "በእውቀት እና በድጋፍ ግለሰቦችን ማብቃት",
    mvvMissionPoint4Desc: "ራስን ለመከበር እና በማህበረሰብ ውስጥ በተግባር እንዲሳተፉ የሚያስችላቸውን እምነት፣ አቅም እና የአመራር ችሎታ መገንባት።",
    // Vision
    mvvVisionTitle: "ራዕይ",
    mvvVisionDesc: "ሁሉም አካል ጉዳተኞች እኩል መብት፣ ተሳትፎ እና ክብር የሚያገኙበት ሁሉን ያካተተ፣ እንቅፋት የሌለበት አዲስ አበባን መፍጠር ።",
    // Impact
    mvvImpactTitle: "የእኛ ተፅዕኖ",
    mvvImpactIntro: "በአመታት ሂደት ውስጥ ማህበራችን አካል ጉዳተኞችን በማብቃት እና በማህበራዊ፣ ኢኮኖሚያዊ እና ፖለቲካዊ ህይወት ሙሉ ተሳትፎን በማስተዋወቅ ውብ ለውጥ ፈጥሯል።",
    mvvImpact1Title: "የመብት ጥበቃ እና ተሟጋችነት",
    mvvImpact1Desc: "የአካል ጉዳተኞችን መብትና ክብር ለማስጠበቅ እንዲሁም ድምፃቸው በፖሊሲዎች፣ በፕሮግራሞች እና በውሳኔ ሰጪነት ሂደቶች ውስጥ እንዲካተት ለማድረግ ከመንግስት አካላት እና ከባለድርሻ አካላት ጋር በቅንጅት መስራት።",
    mvvImpact2Title: "ግንዛቤ እና ማካተት ዘመቻዎች",
    mvvImpact2Desc: "ስለ አካል ጉዳት መብቶች ግንዛቤን የሚያሳድጉ፣ ስቲግማን የሚቀንሱ እና ሁሉን ያካተቱ መንፈሶችን የሚያበረታቱ የትምህርት እና የማህበረሰብ እንቅስቃሴዎች።",
    mvvImpact3Title: "የክህሎት ልማት እና ማብቃት",
    mvvImpact3Desc: "ነፃነት፣ የአመራር ችሎታ እና ንቁ የማህበረሰብ ተሳትፎ እንዲኖራቸው የሚያስችላቸውን ስልጠናዎችን እና የአቅም ግንባታ ፕሮግራሞችን መስጠት።",
    mvvImpact4Title: "የአገልግሎቶች እና የዕድሎች ተደራሽነት",
    mvvImpact4Desc: "አካል ጉዳተኞች ማህበራዊና ኢኮኖሚያዊ ግቦቻቸውን እንዲያሳኩ አስፈላጊው ድጋፍ እየተደረገላቸው፤ ለጤና ጥበቃ፣ ለትምህርት፣ ለሥልጠና እና ለሥራ ስምሪት ፍትሃዊ ተደራሽነት እንዲኖራቸው ማመቻቸት።",
    mvvNetworkTitle: "የኔትወርክ ግንባታ",
    mvvNetworkDesc: "በኢትዮጵያ የአካል ጉዳተኞች ንቅናቄን ለማጠናከር ከአካባቢ እና ከሀገር አቀፍ ድርጅቶች ጋር በመተባበር ለለውጥ እና ለእድገት የተባበረ ድምጽ መፍጠር።",
    // Values
    mvvValuesTitle: "ዋና እሴቶች",
    mvvValuesIntro: "እነዚህ መሰረታዊ መርሆች እያንዳንዱን የሥራችንን ገፅታ የሚመሩ እና አወንታዊ ለውጥ ለማምጣት ያለንን ቁርጠኝነት የሚገልጹ ናቸው።",
    mvvValue1Title: "አካታችነት",
    mvvValue1Desc: "እያንዳንዱ አካል ጉዳተኛ ያለ ምንም አድልዎ እንዲቀበል፣ ዋጋ እንዲሰጠው እና በሁሉም ተግባራት ላይ መሳተፍ እንዲችል ማረጋገጥ።",
    mvvValue2Title: "ትጋት",
    mvvValue2Desc: "ልምዱ ያለው ውጤታማ ተፅዕኖ እንዲኖር ሁሉንም ግዴታዎች በቁርጠኝነት፣ በሥርዓት እና በጠንካራ የስራ ሥነ-ምግባር መፈጸም።",
    mvvValue3Title: "መቻቻል እና የጋራ መከባበር",
    mvvValue3Desc: "የተለያዩ አመለካከቶች የሚከበሩበት፣ እንዲሁም ልዩነቶች በግልጽነት፣ በመረዳዳት እና በፍትሃዊነት የሚታዩበትን አካባቢ መፍጠር።",
    mvvValue4Title: "በጎ ፈቃደኝነት እና በጎ ምኞት",
    mvvValue4Desc: "በሁሉም ተግባራት እና ተሳትፎዎች ውስጥ የግል ጥቅምን ያልፈለገ አገልግሎትን፣ ርህራሄን እና ለማህበረሰቡ አስተዋጽኦ የማበርከት መንፈስን ማበረታታት።",
    mvvValue5Title: "ግልጽነት እና ተጠያቂነት",
    mvvValue5Desc: "በውሳኔ መስጠት፣ በሀብት አስተዳደር እና በድርጅታዊ ተግባር ውስጥ ታማኝነትን ፣ ግልጽነትን እና ተጠያቂነትን መጠበቅ።",
    mvvValue6Title: "በአንድነት መቆም",
    mvvValue6Desc: "የአካል ጉዳተኞችን መብትና ደህንነት ለማስከበር በጋራ ዓላማ እና በፅኑ አጋርነት/አንድነት መስራት።",
    // Alignment
    mvvAlignmentTitle: "ከZOA's WaA ፕሮግራም ጋር ያለው ቅንጅት",
    mvvAlignmentDesc: "የአዲስ አበባ አካል ጉዳተኞች ማህበር (AAAPD)፤ በአዲስ አበባ በሚገኙ አካል ጉዳተኞች መካከል አካታችነትን፣ አቅምን ማሳደግን እና ጥንካሬን (Resilience) በማስፈን ረገድ ከZOA እና WaA ፕሮግራም ግቦች ጋር በቅርበት ይጣጣማል። ሁለቱም ድርጅቶች ዘላቂ የኑሮ መሠረቶችን ለመፍጠር፣ መሰረታዊ አገልግሎቶችን ተደራሽ ለማድረግ እና ለተገለሉ የህብረተሰብ ክፍሎች የማህበረሰብ ተሳትፎን ለማጠናከር የጋራ ቁርጠኝነት አላቸው። የአዲስ አበባ አካል ጉዳተኞች ማህበር (AAAPD) በአቅም ግንባታ፣ በጥብቅና እና በአካታች የልማት ስራዎች አማካኝነት፤ በተለይም በድህነት፣ በስደት ወይም በአካል ጉዳት ለተጎዱ ወገኖች ራሳቸውን የቻሉ እና በክብር የሚመሩበትን ህይወት ለመፍጠር ያለውን የ WaA ፕሮግራም ራዕይ ይደግፋል።",
    // CTA
    mvvCtaTitle: "ተልዕኮአችንን ይቀላቀሉ",
    mvvCtaDesc: "አዲስ አበባን የበለጠ አሳታፊ አድርገን በጋራ መገንባት እንችላለን። አካል ጉዳተኛ ግለሰብ፣ ድርጅት፣ ወይም ደጋፊ (አጋር) ይሁኑ፣ ለለውጥ በሚደረገው ንቅናቄያችን ውስጥ ለእርስዎ ቦታ አለ።",
    mvvCtaExplorePrograms: "ፕሮግራሞችን ያስሱ",
    programs: "ፕሮግራሞች",
    gallery: "ምስሎች",
    members: "አባላት",
    news: "ዜናዎች",
    contactUs: "ያነጋግሩን",
    resources: "መረጃዎች",
    donate: "አስተዋፅዖ ያድርጉ❤️",
    login: "ግባ",
    
    // PublicMembersPage
    publicMembersHeroSubtitle: "በመላው አዲስ አበባ ለውጥ እያመጡ የሚገኙ ንቁ የአካል ጉዳተኞችን ማህበረሰብ ይቀላቀሉ።",
    publicMembersPartnersTitle: "የእኛ አጋር ድርጅቶች",
    publicMembersPartnersDesc: "በአዲስ አበባ ውስጥ ከታላቅ የአካል ጉዳት መብቶች ድርጅቶች ጋር በተባበር እና አወንታዊ ለውጥ ለማመጣት በአንድነት እየሰራን ነው።",
    publicMembersWhyJoin: "እኛን ለምን ይቀላቀሉ?",
    publicMembersBenefitsTitle: "የአባልነት ጥቅሞች",
    publicMembersBenefitsDesc: "ወደ ማህበረሰባችን ሲቀላቀሉ ዕድሎች፣ ድጋፍ እና እድገት ያለውን ዓለም ክፈት።",
    publicMembersBenefit1Title: "ድጋፍ ያለው ማህበረሰብ",
    publicMembersBenefit1Desc: "ጉዞዎን ከሚረዱዎት አቻዎች ጋር በመገናኘት እርስ በርስ ይደጋገፉ እንዲሁም ይበረታቱ።",
    publicMembersBenefit2Title: "ልዩ ፕሮግራሞች",
    publicMembersBenefit2Desc: "ለፍላጎትዎ ተስማሚ ሆነው የተቀረጹ ልዩ ስልጠናዎችን፣ ትምህርቶችን እና የልማት ፕሮግራሞችን ያግኙ።",
    publicMembersBenefit3Title: "ሙያዊ አውታረ መረብ",
    publicMembersBenefit3Desc: "በሚፈልጉት የሥራ መስክ ካሉ አማካሪዎች፣ አሰሪዎች እና ድርጅቶች ጋር ጠንካራ ትስስር ይፍጠሩ።",
    publicMembersBenefit4Title: "የተሟጋችነት መድረክ",
    publicMembersBenefit4Desc: "በፖሊሲ ውይይቶች እና በአካል ጉዳተኞች መብት ጥብቅና ጥረቶች ላይ ድምፅዎ እንዲሰማ ያድርጉ።",
    publicMembersCtaTitle: "ወደ ማህበረሰባችን ለመቀላቀል ዝግጁ ነዎት?",
    publicMembersCtaDesc: "ራስን ለማብቃት እና ለውጥ ለማምጣት የመጀመሪያውን እርምጃ ይውሰዱ።",

    // ProgramsPage (additional labels)
    programsBrowseByCategory: "ፕሮግራሞችን በምድብ ይቃኙ",
    programsClickCategoryToFilter: "ፕሮግራሞችን ለማጣራት ምድብ ይጫኑ",
    programsSearchPlaceholder: "ፕሮግራሞችን ፈልግ...",
    programsAll: "ሁሉም",
    programsImpactLabel: "ተፅዕኖ",
    programsKeyActivitiesLabel: "ዋና እንቅስቃሴዎች",
    programsEmptyTitle: "ፕሮግራሞች አልተገኙም",
    programsEmptyDesc: "ተጨማሪ ፕሮግራሞችን ለማየት ሌላ ምድብ ይሞክሩ።",
    programsTaglineTitle: "አቅም መገንባት። መሰናክሎችን መስበር። ሁሉን አቀፍ ወደፊትን መገንባት።",
    programsTaglineSub: "አቅምን እናበረታታለን፣ መሰናክሎችን እናስበራለን፣ አካታች ወደፊትን እንገንባለን።",
    programsFlowTitle: "ፕሮግራሞቻችን እንዴት ይሰራሉ",
    programsFlow1Title: "ድርሻ መድረስ",
    programsFlow1Desc: "በማኅበረሰብ ውስጥ ካሉ አካል ጉዳተኞች መለያየት እና መገናኘት",
    programsFlow2Title: "ስልጠና",
    programsFlow2Desc: "የክህሎት ልማት እና የትምህርት ፕሮግራሞችን ማቅረብ",
    programsFlow3Title: "ድጋፍ",
    programsFlow3Desc: "ዘላቂ ስኬት ለማስጠናቀቅ የሚያገለግሉ ድጋፎች እና ሀብቶች",
    programsFlow4Title: "ማብቃት",
    programsFlow4Desc: "የሥራ ዕድሎች እና በማህበረሰብ ውስጥ ተሳትፎ",
    programsAccessInclusionTitle: "ተደራሽነት እና ማካተት አገልግሎቶች",
    programsAccessItem1Title: "የመረዳጃ ቴክኖሎጂ እና የእንቅስቃሴ ድጋፍ",
    programsAccessItem1Desc: "ነፃነትን ለማጠናከር እና በዕለታዊ፣ ማህበራዊ እና ኢኮኖሚያዊ ህይወት ሙሉ ተሳትፎን ለማስቻል የሚረዱ መሳሪያዎችን እና መንቀሳቀስ ድጋፎችን መስጠት።",
    programsAccessItem2Title: "የማኅበረሰብ ግንዛቤ እና ማካተት ማበረታታት",
    programsAccessItem2Desc: "አካል ጉዳተኞች ያለ እንቅፋት ሙሉ ተሳትፎ እንዲኖራቸው በማህበረሰብ ውስጥ ግንዛቤን፣ ተቀባይነትን እና አካታች አመለካከቶችን ማበረታታት።",
    programsAccessItem3Title: "ተደራሽ መንቀሳቀስ እና አካታች ንድፍ",
    programsAccessItem3Desc: "በማህበረሰቦች ውስጥ እንቅፋት የሌለ አካባቢ ለመፍጠር ተደራሽ ህንፃዎችን፣ የመንዳት ቦታዎችን፣ መንገዶችን እና ዲጂታል ተደራሽነት መደበኛነትን ማበረታታት።",
    programsAccessItem4Title: "የመብት ጥበቃ እና ህጋዊ ተሟጋትነት",
    programsAccessItem4Desc: "የአካል ጉዳተኞችን መብት ለማስጠበቅ፣ የህዝብ ፖሊሲን ለማተኮር እና አካታች ህጎችን እና ውሳኔ ሂደትን ለማሻሻል ከመንግሥትና ከአጋሮች ጋር መስራት።",
    programsStep2Desc: "ስለ ተወሰኑ እድሎች እና መስፈርቶች በተጨማሪ መረጃ ለማግኘት ከፕሮግራም ኮርድኔተሮቻችን ጋር ያግኙን።",
    programsGetStartedTitle: "ጀምር",
    programsGetStartedDesc: "በመመሪያ ክፍሎች ጋር ጉዞዎትን ጀምሩ እና በማህበረሰብዎ ውስጥ አስፈላጊ ተፅዕኖ ጀምሩ ለማመጣት።",
    programsStartJourney: "ጉዞዎትን ይጀምሩ",
    descriptionLabel: "መግለጫ",

    // AnnualReportPage
    annualReportHeroTitle: "የ AAAPD ዓመታዊ ሪፖርት",
    annualReportTitlePrefix: "AAAPD ዓመታዊ ሪፖርት",
    annualReportLivePreview: "የሪፖርት ቀጥታ እይታ",
    annualReportLivePreviewDesc: "ሙሉ ዓመታዊ ሪፖርቱን በቀጥታ በብራውዘርዎ ይመልከቱ። የዓመቱን ስኬቶች እና ተፅእኖዎች በተመለከተ ያለንን አጠቃላይ ግምገማ ለማሰስ፣ ለማጉላት (ዙም ለማድረግ) እና ለመቃኘት መቆጣጠሪያዎቹን ይጠቀሙ።",
    annualReportIntro1: "በየ2024 ዓ.ም ዓመታዊ ሪፖርታችን ውስጥ ከ2.1 ሚሊዮን በላይ ሰዎች ሕይወት ላይ የፈጠረነውን ተፅዕኖ እናቀርባለን።",
    annualReportIntro2: "አለምዓቀፍ ፈተናዎች እና የወጪ መጠነኛ ሆኖ ቢኖርም፣ በ2024 ዓ.ም ለአካል ጉዳተኞች እና ለተለማዶ ቡድኖች ፍላጎት ተጨምሯል።",
    annualReportIntro3: "በምክክር፣ በማህበረሰብ ተሳትፎ እና በማብቃት ፕሮግራሞች በኩል AAAPD በአዲስ አበባ እና በአካባቢዋ ውስጥ እውነተኛ እና አወንታዊ ለውጥ አመጣ።",
    annualReportIntro4: "ይህ ዓመታዊ ሪፖርት እነዚህን ስኬቶች ይወጣጠራል እና ሙሉ በሙሉ አካታች የወደፊት ራዕያችንን ያቀርባል።",
    annualReportDownloadPrefix: "የ AAAPD ዓመታዊ ሪፖርትን ያውርዱ",
    annualReportDownloadSuffix: "(PDF)",
    annualReportDownloadsTitle: "የAAAPD ቀደምት ሪፖርቶች ለማውረድ",
    annualReportDownloadsDesc: "ጉዞአችንን እንዲሁም ለአካል ጉዳተኞች መብትና ተጠቃሚነት ያለንን ቀጣይ ቁርጠኝነት ለመረዳት ያለፉትን ዓመታት አጠቃላይ ዓመታዊ ሪፖርቶች ተመልከቱ።",
    annualReportNoPrevious: "ያለፉ ሪፖርቶች የሉም።",
    annualReportCardTitle: "ዓመታዊ ሪፖርት",
    reportLabel: "ሪፖርት",
    downloadPdf: "PDF ያውርዱ",
    // PDF viewer strings
    searchInPdf: "በ PDF ውስጥ ፈልግ",
    sharePdf: "PDF አጋራ",
    exitFullscreen: "ከሙሉ ማያ ውጣ",
    enterFullscreen: "ወደ ሙሉ ማያ ግባ",
    searchInPdfPlaceholder: "በ PDF ውስጥ ፈልግ...",
    searchButton: "ፈልግ",
    searchFoundPrefix: "ተገኝቷል",
    searchResultsPlural: "ውጤቶች",
    searchResultsSingular: "ውጤት",
    searchFor: "ለ",
    pageLabel: "ገጽ",
    matchesPlural: "ተመሳሳይ",
    matchesSingular: "ተመሳሳይ",
    clickToView: "ለመመልከት ጠቅ ያድርጉ",
    andPrefix: "እና",
    moreResultsSuffix: "ተጨማሪ ውጤቶች",
    noResultsFound: "ምንም ውጤት አልተገኘም ለ",
    tryDifferentKeywords: "የተለያዩ ቁልፍ ቃላትን ይሞክሩ ወይም ፊደል ያረጋግጡ",
    annualReportFallbackTitle: "ዓመታዊ ሪፖርት",
    annualReportInteractivePreview: "ተግባራዊ የ PDF ቅድመ እይታ",
    annualReportUnsupportedMessage: "አሳሽዎ የ PDF ቅድመ እይታን አይደግፍም።",
    annualReportViewDirectLink: "PDF በቀጥታ ለማየት እዚህ ጠቅ ያድርጉ",
    
    // Footer
    footerAboutBlurb: "አካል ጉዳተኞችን በተደራሽ አገልግሎቶች፣ እድሎች እና የማህበረሰብ ተሳትፎ ለማሳወቅ፣ ለመደገፍ እና ለማበረታታት ያለመ ድህረ ገጽ።",
    quickLinks: "ፈጣን አገናኞች",
    fundedBy: "በገንዘብ የተደገፈው በ",
    zoaTagline: "ZOA - from relief to recovery",
    WaATagline: "We are Able",
    zoaFundedNote: "ይህ ድህረ ገጽ በ ZOA እና በ We are Able የተደገፈ ነው።",
    rightsReserved: "መብቱ በህግ የተጠበቀ ነው።",
    
    // Hero Section
    heroTitle: "አዲስ አበባ አካል ጉዳተኞች ማህበር",
    heroSubtitle: "አካል ጉዳተኞችን በተደራሽ አገልግሎቶች፣ እድሎች እና የማህበረሰብ ተሳትፎ ለማሳወቅ፣ ለመደገፍ እና ለማበረታታት ያለመ ድህረ ገጽ።",
    accessDashboard: "የእኛ አውታረ መረብ አካል ይሁኑ",
    learnMore: "ተጨማሪ ይወቁ",
    
    // About Section
    aboutMission: "ስለ ተልዕኮአችን",
    aboutTitle: "መብቶችን ማስከበር፣ መሰናክሎችን ማስወገድ",
    aboutDescription: "አካል ጉዳተኞች በማህበረሰቡ ውስጥ እኩል ተሳታፊ እና ፍትሃዊ ተጠቃሚ እንዲሆኑ ለማረጋገጥ ቁርጠኞች ነን። ግንዛቤን በማሳደግ እንዲሁም ግብዓቶችን፣ ድጋፎችንና እድሎችን በማቅረብ፤ ግለሰቦች ማህበራዊ፣ ኢኮኖሚያዊና ፖለቲካዊ መብቶቻቸውን ሙሉ በሙሉ እንዲጠቀሙ አቅም እንፈጥራለን።",
    promoteAccess: "ተደራሽነትን እና አካታችነትን ማራመድ",
    connectOPDs: "ከኦፒዲዎች እና ከአጋሮች ጋር ትስስር መፍጠር",
    supportingMembers: "በሀገር አቀፍ ደረጃ በሺዎች የሚቆጠሩ አባላትን መደገፍ።",
    buildingNetwork: "ለድጋፍ እና እንክብካቤ ኃይለኛ አውታር መገንባት።",
    
    // AboutUsPage - Story/Timeline
    aboutBackgroundTitle: "መደበኛ መግቢያ",
    aboutBackgroundDesc: "የአዲስ አበባ የአካል ጉዳተኞች ማህበር (AAAPD) የአካል፣ የመስማት፣ የማየት፣ የአዕምሮ እና የስነ-ልቦና እክልን ጨምሮ ሁሉንም አይነት አካል ጉዳተኞች አንድ የሚያደርግ ጃንጥላ ድርጅት ነው። ማህበሩ የተመሰረተው መገለልን ለመዋጋት፣ ማካተትን ለማበረታታት እና በዋና ከተማው ውስጥ እኩል መብቶችን እና እድሎችን ለመደገፍ ነው።",
    umbrellaTitle: "የአዲስ አበባ አካል ጉዳተኞች ማህበር",
    umbrellaText: "የአዲስ አበባ አካል ጉዳተኞች ማህበር(AAAPD) ሁሉንም ዓይነት የአካል ጉዳት ያለባቸውን ሰዎች—ማለትም አካላዊ፣ የመስማት፣ የማየት፣ የአዕምሮ እድገት እና የስነ-ልቦና ማህበራዊ ጉዳቶችን—በአንድ ላይ የሚያቀፍ የከተማ አቀፍ ጥላ ድርጅት ነው። ፌዴሬሽኑ የተመሰረተው መገለልን ለመቅረፍ፣ አካታችነትን ለማስፋፋት እንዲሁም በዋና ከተማዋ እኩል መብትና ዕድሎች እንዲከበሩ ጥብቅና ለመቆም ነው።",
    visionMissionTitle: "ራዕይ እና ተልዕኮ",
    visionMissionText: "የአዲስ አበባ አካል ጉዳተኞች ማህበር (AAAPD) ሁሉም አካል ጉዳተኞች እኩል መብት፣ ተሳትፎ እና ክብር የሚያገኙበት ሁሉን ያካተተ፣ እንቅፋት የሌለበት አዲስ አበባ ያስባል። ተልእኮው አካል ጉዳተኞችን የሚያበረታቱ እና በሁሉም ደረጃዎች የትምህርት፣ የጤና፣ የስራ፣ የማህበራዊ አገልግሎት እና የውሳኔ አሰጣጥ እድሎችን የሚያሻሽሉ ፕሮግራሞችን መደገፍ፣ ማስተባበር እና መተግበር ነው።",
    coreObjectivesTitle: "ዋና ዓላማዎች",
    coreObjectivesText: "AAAPD የአካል ጉዳተኞችን መብትና ጥቅም ለማስተዋወቅ፣ በሁሉም ዘርፎች አካል ጉዳተኝነትን ያካተተ ልማትን ለማጠናከር እና በክህሎት ስልጠና እና በቅጥር ፕሮግራሞች ኢኮኖሚያዊ ማጎልበትን ለመደገፍ ይሰራል። ማህበሩ ተደራሽ መሠረተ ልማቶችን፣ መረጃዎችን እና አገልግሎቶችን የሚደግፍ ሲሆን በመላው አዲስ አበባ የሚገኙ የአካል ጉዳተኞች ማህበራትን እና መሰረታዊ ቡድኖችን ያስተባብራል።",
    structureMembershipTitle: "መዋቅር እና አባልነት",
    structureMembershipText: "የአዲስ አበባ አካል ጉዳተኞች ማህበር (AAAPD) በሊቀመንበር በሚመራ ሥራ አስፈፃሚ ኮሚቴ የሚንቀሳቀስ ሲሆን፤ በሁሉም 11 የአዲስ አበባ ክፍለ ከተሞች እና በወረዳ ደረጃ ያሉ መዋቅሮችን ያካትታል። አባልነቱ የተለያዩ የአካል ጉዳት ያለባቸውን ግለሰቦች እንዲሁም በአካል ጉዳተኞች የሚመሩ ድርጅቶችን (OPDs) ያቀፈ ነው። ፌዴሬሽኑ በመሪነት እና በውክልና ሂደቱ ውስጥ ሴቶችን፣ ወጣቶችን እና ሁሉንም የአካል ጉዳት አይነቶችን ባሳተፈ መልኩ ሆን ተብሎ አካታች እንዲሆን ተደርጎ የተዋቀረ ነው።",
    keyProgramAreasTitle: "ዋና የፕሮግራም መስኮች",
    keyProgramAreasText: "ማህበሩ ስለ አካል ጉዳተኞች መብቶች እና የህግ ጥበቃ፣ የአቅም ግንባታ እና የአመራር ልማት፣ የኑሮ እና የክህሎት ስልጠና እና ሁሉን አቀፍ ትምህርት እና የጤና አገልግሎቶችን በማስተዋወቅ በጥብቅና እና በፖሊሲ ተጽእኖ ላይ ይሳተፋል። AAAPD በተደራሽነት እና በማህበራዊ ጥበቃ እንዲሁም በማህበረሰብ ቅስቀሳ እና አጋርነት ግንባታ ላይ ያተኩራል ዘላቂ ሁሉን አቀፍ ለውጥን ለመደገፍ።",
    partnershipsTitle: "አጋርነት እና ኢላማ ቡድኖች",
    partnershipsText: "የአዲስ አበባ አካል ጉዳተኞች ማህበር (AAAPD) እንደ ሰራተኛና ማህበራዊ ጉዳይ፣ ሴቶችና ማህበራዊ ጥበቃ፣ ትምህርት እና ጤና ቢሮዎች ካሉ ቁልፍ የመንግስት መስሪያ ቤቶች ጋር በቅንጅት ይሰራል። በተጨማሪም ከሲቪል ማህበረሰብ ድርጅቶች፣ መንግስታዊ ካልሆኑ ድርጅቶች (NGOs)፣ ከአካል ጉዳተኞች ማህበራት መረቦች (DPO networks)፣ ከዓለም አቀፍ አጋሮች እና ከማህበረሰብ አቀፍ ማህበራት ጋር በትብብር ይንቀሳቀሳል።",
    guidingPrinciplesTitle: "የመመሪያ መርሆዎች እና የወደፊት አቅጣጫ",
    guidingPrinciplesText: "በመደመር፣ በእኩልነት እና አድልዎ የሌለበት፣ በተሳትፎ፣ በተደራሽነት እና በተጠያቂነት እና ግልጽነት መርሆዎች በመመራት AAAPD በአዲስ አበባ እንደ መሪ የአካል ጉዳተኛ ድርጅት ሚናውን ማጠናከሩን ቀጥሏል። ማህበሩ ሁሉን አቀፍ ፕሮግራሞችን በማስፋፋት፣ ስርዓቶችን በማሻሻል እና አካል ጉዳተኞች በሁሉም የማህበራዊ፣ ኢኮኖሚያዊ እና የፖለቲካ ህይወት ዘርፎች ሙሉ በሙሉ እንዲወከሉ በማድረግ ተፅዕኖውን ለማሳደግ ያለመ ነው።",
    aboutTaglineTitle: "መሰናክሎችን መስበር. ችሎታዎችን ማበረታታት. ህይወትን መለወጥ",
    aboutTaglineSub: "መሰናክሎችን መስበር. ችሎታዎችን ማበረታታት. ህይወትን መለወጥ።",

    // Partners Section (About)
    partnersHeading: "አጋሮቻችን",
    partnersIntro: "በአዲስ አበባ ለአካል ጉዳተኞች ዘላቂ ለውጥ ለመፍጠር ከዋና ድርጅቶችና ተቋማት ጋር በጋራ እንሰራለን።",
    partnerZOATitle: "ZOA",
    partnerZOADesc: "በመላው አዲስ አበባ የአካል ጉዳተኞች ተሟጋችነት እና የማህበረሰብ ልማት ተነሳሽነት ቁርጠኛ አጋር።",
    partnerWAATitle: "We Are Able",
    partnerWAADesc: "አካል ጉዳተኞችን በፈጠራ ፕሮግራሞች እና ሁሉን አቀፍ የማህበረሰብ ግንባታ ማበረታታት።",
    partnerDPOTitle: "DPO ኔትወርኮች",
    partnerDPODesc: "የጋራ ድምፅን፣ መሪነትን እና የመሰረታዊ አባላትን ተፅዕኖ ለማጎልበት፤ በአካል ጉዳተኞች የሚመሩ ድርጅቶችን (OPDs) ማጠናከር።",
    partnerInternationalTitle: "አለምአቀፍ አጋሮች",
    partnerInternationalDesc: "የኢኮኖሚ ዕድሎችን የሚያሰፉ እና ማህበራዊ አካታችነትን የሚያረጋግጡ ዘላቂ የልማት ስራዎች ላይ በቅንጅት መስራት።",
    partnerCSOTitle: "የሲቪል ማህበረሰብ ድርጅቶች",
    partnerCSODesc: "እኩልነትን፣ ተሳትፎን እና ማህበራዊ ለውጥን የሚያበረታቱ ማህበረሰብ-ተኮር መፍትሄዎችን በጋራ ለማቅረብ በአጋርነት መስራት።",
    partnerGovTitle: "የመንግስት ቢሮዎች (ሥራ እና ማህበራዊ ጉዳይ፣ ሴቶች እና ማህበራዊ ጥበቃ፣ ትምህርት፣ ጤና)",
    partnerGovDesc: "አካታች ፖሊሲዎች፣ ተደራሽ አገልግሎቶች እና በሁሉም ዘርፎች ላይ ስርአታዊ ለውጥ እንዲመጣ ከመንግስት ተቋማት ጋር በቅርበት መስራት።",

    // Call to Partnership (About)
    callPartnershipTitle: "አጋርነት ይፈልጋሉ?",
    callPartnershipDesc: "አዲስ አበባን አካታች ለመገንባት ይቀላቀሉን። ለአካል ጉዳተኞች መብቶች እና ማካተት ከተሰጡ ድርጅቶች፣ ንግዶች እና ግለሰቦች ጋር ሽርክና በደስታ እንቀበላለን።",
    callPartnershipCta: "ያነጋግሩን",
    
    // Features Section
    featuresTitle: "የእኛ አላማዎች",
    featuresTitle2: "የእኛን ተጽዕኖ ያግኙ",
    featuresTitle3: "በመላው ኢትዮጵያ በአካል ጉዳተኞች ህይወት ላይ እንዴት ለውጥ እያመጣ እንዳለን ይመልከቱ",
    featuresTitle4: "ስለፕሮግራሞቻችን እና ስለምናገለግላቸው ማህበረሰቦች የበለጠ ይወቁ",
    featuresSubtitle: "ስለ አላማዎቻችን ማወቅ እና መረዳት ያለብዎት ነገር ሁሉ።",
    memberManagement: " የአካል ጉዳተኞችን መብትና ሰብአዊ ክብርን ማስጠበቅ በተለይም የጤና የመጠለያ የትምህርት፣ የስልጠናና የስራ ዕድል እንዲያገኙ መጣር::",
    memberManagementDesc: "ሰብዓዊ መብቶችን ማስከበር፣ እኩልነትን ማረጋገጥ እንዲሁም በኢኮኖሚያዊ፣ ፖለቲካዊ እና ማህበረሰባዊ ህይወት ውስጥ  ሁለንተናዊ አካታችነትን ማራመድ።",
    supportTrackings: "በሁሉም ዘርፎች አካል ጉዳተኝነትን ያካተተ ልማትን ማጠናከር።",
    supportTrackingDesc: "ስለ አካል ጉዳተኝነት ትክክለኛ ግንዛቤን ማሳደግ፣ አካታች ፖሊሲዎችንና አገልግሎቶችን ማስፋፋት፣ እንዲሁም በየደረጃው የሚደረጉ የልማት ጥረቶች የአካል ጉዳተኞችን ፍላጎትና አቅም ያገናዘቡ መሆናቸውን ማረጋገጥ።",
    secureCommunication: "አካል ጉዳተኞች በማሀበራዊ ኢኮኖሚያዊ ፖለቲካዊና ሌሎች ልማታዊ ስራዎች ላይ እኩል ተሳታፊና ተጠቀሚ እንዲሆን ማድረግ።",
    secureCommunicationDesc: "በሙያ ስልጠና፣ በዲጂታል ክህሎት እድገት፣ ለስራ ፈጠራ ድጋፍ እና በስራ ምደባ ፕሮግራሞች ትርጉም ያለው የስራ እድል መፍጠር።",
    dataReporting: "አካል ጉዳተኞች ያለባቸውን የሰውሰራሽ አካልና ያካል ድጋፍ እንዲሁም የተስማሚ ቴክኖሎጂ ውጤቶች አቅርቦት ችግር መፍትሄ የሚያገኙበትን ሁኔታ ማመቻቸት።",
    dataReportingDesc: "ነፃነትን እና ሙሉ ተሳትፎን ለማሳደግ የአካል፣ ዲጂታል እና የግንኙነት ተደራሽነት እድገትን እና ማሻሻልን ይደግፉ - ተደራሽ መሠረተ ልማትን፣ መረጃዎችን እና አገልግሎቶችን ማስተዋወቅ።",
    dataReporting2: "የክፍለ ከተማ የአካል ጉዳተኞች ማህበራትን እና መሰረታዊ ቡድኖችን ማሰባሰብ እና ማስተባበር።",
    dataReportingDesc2: "በኦፒዲዎች፣ በማህበረሰብ ቡድኖች እና በመሠረታዊ ድርጅቶች መካከል ትብብርን፣ አመራርን እና የጋራ እርምጃን በመደገፍ የተደራጁ የአካል ጉዳተኞች ኔትወርኮችን ማጠናከር።",
    dataReporting3: "የአካል ጉዳተኞችን ማካተትን ለማበረታታት ከመንግስት፣ መንግስታዊ ያልሆኑ ድርጅቶች እና አለም አቀፍ ድርጅቶች ጋር መስራት።",
    dataReportingDesc3: "ሁሉን አቀፍ አስተዳደርን፣ የሰላም ግንባታን፣ የፕሮግራም አተገባበርን እና በመብቶች ላይ የተመሰረቱ የአካል ጉዳተኞችን ተነሳሽነት ለማስተዋወቅ ጠንካራ፣ የትብብር ሽርክናዎችን ማዳበር።",

    // Social Proof Section
    trustedTitle: "በሀገር አቀፍ ደረጃ በድርጅቶች የተመሰከረለት",
    trustedSubtitle: "ትርጉም ያለው ለውጥ ለማምጣት ከ OPDs ጋር በመተባበር እንኮራለን።",
    opdsPartnered: "የተባበሩ OPDs",
    membersSupported: "የተደገፉ አባላት",
    projectsImplemented: "የመንግስት እና መንግስታዊ ያልሆኑ ድርጅቶች ሽርክና",
    offlineFirst: "ከመስመር-ውጭ-መጀመሪያ",
    reliableAccessible: "አስተማማኝ እና ተደራሽ",
    
    // Testimonials Section
    testimonial: "ምስክርነት",
    testimonialsTitle: "ሰዎች ስለ ስራችን የሚሉት",
    trustedPartners: "ከ",
    partners: "አጋሮች በላይ የተመሰከረለት",
    allTestimonials: "ሁሉም ምስክርነቶች",
    testimonial1: "በአደገኝ ጊዜ፣ ተገለልኩ ብዬ ይሰማኝ ነበር። የ AAAPD የምክር እና ማብቃት ፕሮግራሞች እምነትዬን እንድሰራ እና ሌሎችን እንድመራ ረድተዋል።",
    testimonial1Name: "ሜሮን መኩሪያ",
    testimonial1Title: "የወዳጅ አማካሪ",
    testimonial2: "በአካባቢያችን ተደራሽነት ተግዳሮት ነበር፣ ነገር ግን ምስጋና ለ AAAPD፣ የአካባቢያችን ማእከል አሁን ለሁሉም — የዊልቸር ተጠቃሚዎች ለሁሉም ክፍት ነው።",
    testimonial2Name: "ራሔል በቀለ",
    testimonial2Title: "የማህበረሰብ ተሟጋች",
    testimonial3: "የአመራር አውደ ጥናቶች ለማካተት እንድናገር አነሳስተዋል። አሁን እኩልነትን እና ተደራሽነትን የሚያስተዋውቁ የወጣቶች ተነሳሽነቶችን እመራለሁ።",
    testimonial3Name: "መኮንን ተስፋይ",
    testimonial3Title: "የወጣቶች ተሳታፊ",
    
    // News Section
    newsTitle: "የቅርብ ጊዜ ዜናዎች እና ዝመናዎች",
    newsSubtitle: "ስለ ቅርብ ጊዜ እንቅስቃሴዎቻችን እና ተፅዕኖአችን መረጃ ያግኙ።",
    news1Title: "የዲጂታል ማንበብና መጻፍ ለማስፋት አዲስ ሽርክና",
    news1Desc: "ከ Tech for All ጋር በመተባበር ለ500 በላይ አባላት የዲጂታል ክህሎት ስልጠና እንሰጣለን።",
    news2Title: "አመታዊ ጠቅላላ ጉባኤ ቁልፍ ስኬቶችን አጉልቷል",
    news2Desc: "የ2024 AGM የእድገት አመትን አከበረ፣ በአባላት ድጋፍ 20% ጭማሪ።",
    news3Title: "የከመስመር-ውጭ-መጀመሪያ ሞባይል መተግበሪያ ማስጀመር",
    news3Desc: "አዲሱ የሞባይል መተግበሪያችን አባላት የበይነመረብ ግንኙነት ባይኖራቸውም ሀብቶችን መድረስ እንደሚችሉ ያረጋግጣል።",
    readMore: "ተጨማሪ ያንብቡ",
    
    // NewsPage Section
    newsPageTitle: "የቅርብ ጊዜ ዜናዎች",
    newsPageSubtitle: "ከማህበረሰባችን የሚወጡ አዳዲስ መረጃዎችን፣ የስኬት ታሪኮችን እና ማስታወቂያዎችን በቅርብ ይከታተሉ።",
    featuredLabel: "ተመርጦ የቀረበ",
    breakingNews: "አዲስ ዜና",
    recentUpdates: "የቅርብ ጊዜ ዜናዎች",
    recentUpdatesDesc: "በማህበረሰባችን ውስጥ የሚከሰቱትን የቅርብ ጊዜ ክስተቶች ይከታተሉ።",
    readFullStory: "ሙሉ ታሪኩን ያንብቡ",
    stayInformed: "መረጃ ያግኙ",
    stayInformedDesc: "የቅርብ ጊዜ ዜናዎችን እና ዝመናዎችን በቀጥታ በኢሜልዎ ለመቀበል ለዜና መልእክታችን ይመዝገቡ።",
    subscribeNow: "አሁን ይመዝገቡ",
    // NewsPage additions
    newsSource: "የዜና ምንጭ",
    disabilityNewsPill: "የአካል ጉዳት ዜና",
    disabilityHeadlinesTitle: "ዓለም አቀፍ እና የኢትዮጵያ የአካል ጉዳት ዜናዎች",
    disabilityHeadlinesDesc: "ስለ የአካል ጉዳት መብቶች፣ ማካተት፣ የፖሊሲ ለውጦች እና ተደራሽነት በቀጥታ ዝርዝሮች — በኢትዮጵያ እና በዓለም ላይ ያሉ እድገቶች ላይ ትኩረት ይዞ።",
    ethiopiaFocusLabel: "የኢትዮጵያ ትኩረት",
    globalPerspectiveLabel: "ዓለም አቀፍ እይታ",
    ethiopiaSectionTitle: "ኢኢትዮጵያ – አካል ጉዳተኞች",
    ethiopiaEmpty: "በአሁኑ ጊዜ ከኢትዮጵያ ጋር የተያያዘ የአካል ጉዳት ዜና አልተገኘም።",
    globalHighlightsTitle: "ዓለም አቀፍ የአካል ጉዳተኝነት አበይት ክንውኖች",
    globalEmpty: "በአሁኑ ጊዜ አዲስ ዓለም አቀፍ የአካል ጉዳት ዜና አልተገኘም።",
    ethiopiaCategoryLabel: "ኢትዮጵያ / የአካል ጉዳት",
    newsQuoteBanner: "በአዲስ አበባ አካል ጉዳተኞች ማህበር (AAAPD) እና በስሩ ባሉ 11 የአካል ጉዳተኞች ማህበራት (OPDs) አማካኝነት የጥብቅና ስራን በማጠናከር፤ የአካል ጉዳተኞችን መብት፣ ክብር እና ደህንነት ማረጋገጥ እንዲሁም ለሁሉም እኩል የሆነችና አካታች አዲስ አበባን መገንባት ይቻላል።",
    advocacyPolicyTitle: "የአዲስ አበባ አካል ጉዳተኞች ማህበር የጥብቅና እና ፖሊሲ ስራዎች",
    advocacyAwarenessTitle: "የግንዛቤ ማስጨበጫ ዘመቻዎች",
    advocacyAwarenessDesc: "የአዲስ አበባ አካል ጉዳተኞች ማህበር (AAAPD) እና በስሩ ያሉ 11 የአካል ጉዳተኞች ማህበራት (OPDs) ማህበረሰቡ ስለ አካል ጉዳተኞች መብት እንዲገነዘብ፣ የተሳሳቱ አመለካከቶችን እንዲታገሉ እና አካታችነትን እንዲያበረታቱ በመላው አዲስ አበባ ህዝባዊ ንቅናቄዎችን ይመራሉ።",
    advocacyPolicyEngTitle: "የፖሊሲ ተሳትፎ",
    advocacyPolicyEngDesc: "በትምህርት፣ በሥራ ስምሪት፣ በጤና እንክብካቤ፣ በተደራሽነት እና በማህበራዊ ጥበቃ ዘርፎች ላይ ትኩረት በማድረግ፤ በአዲስ አበባ ከተማ እና በክፍለ ከተማ ደረጃዎች አካታች ፖሊሲዎች እንዲተገበሩ ጥብቅና መቆም።",
    advocacyMediaTitle: "የማህበረሰብ እና የሚዲያ ተሳትፎ",
    advocacyMediaDesc: "የአካል ጉዳተኞች ማህበራትን (OPDs) ድምፅ ለማጉላት እና የአዲስ አበባ አካል ጉዳተኞች ማህበርን (AAAPD) ህዝባዊ ተደራሽነት ለማጠናከር፤ የአባላትን ታሪክ፣ የፕሮግራም ውጤቶችን እና ምርጥ ተሞክሮዎችን ያጋሩ።",
    advocacyImageAlt: "የ AAAPD ውይይት",
    advocacyImageSr: "የ AAAPD ተሟጋትነት ስልጠና",
    inclusivenessTitle: "ለአካል ጉዳተኞች ማህበራት (OPDs) አካታችነት እና አቅም ግንባታ",
    inclusivenessTrainingTitle: "የድርጅቶቹ ሰራተኞች ስልጠና",
    inclusivenessTrainingDesc: "ለዳታ ክለርኮች (Data Clerks)፣ ለመሪዎች እና ለኬዝ ወርከሮች (Case Workers) በምዝገባ፣ በድጋፍ ክትትል፣ በሪፖርት አቀራረብ እና በኮሙኒኬሽን ዙሪያ የሚሰጥ ተግባራዊ ስልጠና።",
    inclusivenessNetworkTitle: "ትስስር እና ቅንጅት",
    inclusivenessNetworkDesc: "ቅድሚያ የሚሰጣቸውን ጉዳዮች ለማስተካከል እና ግብዓቶችን በጋራ ለመጠቀም በድርጅቶቹ (OPDs)፣ በማህበሩ (AAAPD) እና በባለድርሻ አካላት መካከል ያለውን ቅንጅት ማጠናከር።",
    inclusivenessMonitoringTitle: "ክትትል እና ተጠያቂነት",
    inclusivenessMonitoringDesc: "የገቡ ቃላቶችን እና የተገኙ ውጤቶችን መከታተል፤ ተቋማት ለአካል ጉዳተኞች መብት ተጠያቂ እንዲሆኑ የሚያደርጉ ግልጽ ሪፖርቶችን ማዘጋጀት።",
    inclusivenessLegalTitle: "ህግ ድጋፍ እና የክስ ክትትል",
    inclusivenessLegalDesc: "አባላትን ከህግ ድጋፍ እና መብትን መሰረት ካደረጉ አገልግሎቶች ጋር ማገናኘት፤ እንዲሁም እንደ አስፈላጊነቱ የተባበሩት መንግስታት የአካል ጉዳተኞች መብት ኮንቬንሽን (CRPD) አሰራሮችን መጠቀም።",
    miniLinkageTitle: "የድርጅቶች እና የባለድርሻ አካላት ትስስር (",
    miniLinkageDesc: "ከባለድርሻ አካላት ጋር ግንኙነት መፍጠር፤ በአገር አቀፍ እና በዓለም አቀፍ መድረኮች ላይ በመሳተፍ የድርጅቶችን ተጠቃሚነት ማሳደግ።",
    miniEvidenceTitle: "መረጃን መሰረት ያደረገ ሪፖርት",
    miniEvidenceDesc: "ከአካል ጉዳተኞች ማህበራት (OPDs) የሚገኙ መረጃዎችን ማሰባሰብ፤ ለለጋሾች እና ለባለድርሻ አካላት ተደራሽ የሆኑና ግልጽ የሆኑ ሪፖርቶችን ማዘጋጀት።",
    miniDataTitle: "በመረጃ የተደገፈ ዕቅድ",
    miniDataDesc: "የተሰበሰቡ መረጃዎችን በመተንተን፤ ቅድሚያ የሚሰጣቸውን ጉዳዮች መለየት፣ ግብዓቶችን በፍትሃዊነት መመደብ እና የተገኘውን ተጨባጭ ለውጥ ማሳየት።",
    miniResourceTitle: "የሃብት ማሰባሰብ",
    miniResourceDesc: "ጠንካራ ተደራሽነት እና ተዓማኒነት ያለው መረጃ መኖር፤ የገንዘብ ድጋፍን እና የረጅም ጊዜ አጋርነትን ለመሳብ ይረዳል።",

    // AssociationDashboard (AM)
    assocDashboardTitle: "የአዲስ አበባ የአካል ጉዳተኞች ማህበር ዳሽቦርድ",
    assocDashboardWelcome: "እንኳን ደህና መጡ፣ የማህበሩ እንቅስቃሴዎች ጠቅላላ እይታ እነሆ።",
    latestDisNews: "የቅርብ ጊዜ የአካል ጉዳት ዜና",
    searchPlaceholder: "መፈለጊያ ቁልፍ ቃል...",
    localNews: "የውስጥ ማስታወቂያዎች",
    ethiopiaNews: "የሀገር ውስጥ ዜና",
    worldwideNews: "ዓለም አቀፍ ዜና",
    search: "ፈልግ",
    loadingNews: "ዜና በመጫን ላይ...",
    noLocalNewsFound: "የውስጥ ማስታወቂያዎች አልተገኙም።",
    noNewsFound: "ለዚህ ቁልፍ ቃል/አገር ዜና አልተገኘም።",
    couldNotLoadNews: "በዚህ ጊዜ ዜናን መጫን አልተቻለም።",
    numberOfMembers: "የአባላት ብዛት",
    unknownSource: "ያልታወቀ ምንጭ",
    aaapdNewsSource: "AAAPD ዜና",
    externalNewsCategory: "የውጭ ዜና",
    newsCategory: "ዜና",
    totalOpds: "ጠቅላላ OPDs",
    totalMembers: "ጠቅላላ አባላት",
    averageAge: "አማካይ ዕድሜ",
    genderSplit: "የሥርዓተ-ፆታ ስርጭት",
    membersByDisability: "አባላት በአካል ጉዳት አይነት",
    membersByGender: "አባላት በጾታ",
    close: "ዝጋ",
    // Disability and gender labels
    disTypeVisual: "የእይታ እክል",
    disTypeHearing: "የመስማት እክል",
    disTypePhysical: "አካላዊ/የእንቅስቃሴ እክል",
    disTypeIntellectual: "አእምሮ ጉዳት",
    disTypeMentalHealth: "የአእምሮ ጤና ፍርግርግ",
    disTypeChronicIllness: "ረጅም ጊዜ በሽታ",
    disTypeSpeech: "የንግግር እክል",
    disTypeOther: "ሌላ",
    noDescription: "መግለጫ የለም።",
    
    // DisabilityPoliciesResearchPage
    policiesViewDocument: "ሰነዱን ይመልከቱ",
    policiesDownloadPdf: "PDF ያውርዱ",
    policiesHeroPill: "የአካል ጉዳት ፖሊሲዎች እና ምርምር መድረክ",
    policiesHeroTitlePrefix: "ማስረጃ፣ ህጎች እና መሣሪያዎች ለ",
    policiesHeroTitleHighlight: "የአካል ጉዳት አካባቢ",
    policiesHeroDesc: "ይህ ገጽ ስለ አካል ጉዳተኞች መብቶች ዋና ብሔራዊ ፖሊሲዎችን፣ ዓለም አቀፍ ስምምነቶችን፣ ምርምሮችን፣ ሪፖርቶችን እና ተግባራዊ መመሪያዎችን ያዋቅራል። ለ AAAPD፣ ለአባል OPDs፣ ለመንግስት ቢሮዎች እና ለአጋሮች የአካል ጉዳትን ያካተቱ ፕሮግራሞችን ለመከታተል፣ ለመሟገት እና ለማተግበር ይደግፋል።",
    policiesQuickOverview: "አጭር እይታ",
    policiesQuickOverviewDesc: "ፖሊሲዎች፣ ስምምነቶች፣ ምርምር፣ ሪፖርቶች እና መመሪያዎች",
    policiesBullet1: "ብሔራዊ የአካል ጉዳት ህጎች እና ስትራቴጂዎች (ኢትዮጵያ)",
    policiesBullet2: "የአውን ክርፕዲ (UN CRPD)፣ የአፍሪካ የአካል ጉዳት ፕሮቶኮል እና SDGs",
    policiesBullet3: "ቁልፍ ምርምሮች እና የአገር ደረጃ ጥናቶች",
    policiesBullet4: "ለ OPDs፣ NGOs እና መንግስት ተግባራዊ መሣሪያዎች",
    policiesNationalTitle: "ብሔራዊ የአካል ጉዳት ፖሊሲዎች እና ህጎች (ኢትዮጵያ)",
    policiesNationalSubtitle: "በክፍሎች ውስጥ የአካል ጉዳት መብቶችን፣ ማካተትን እና አገልግሎቶችን የሚመሩ ዋና ብሔራዊ መሠረቶች።",
    policiesInternationalTitle: "ዓለም አቀፍ እና ክልላዊ መዋቅሮች",
    policiesInternationalSubtitle: "ኢትዮጵያ የተገዛበት ዓለም አቀፍ እና አፍሪካዊ የሰብአዊ መብት መሣሪያዎች – ለተሟጋትነት የ OPDs ሊጠቀሙባቸው የሚችሉ።",
    policiesResearchTitle: "ስለ የአካል ጉዳት ምርምር እና ማስረጃ",
    policiesResearchSubtitle: "ለየአካል መብቶች ያካተቱ ፖሊሲዎች ምክር የሚሰጡ ዓለም አቀፍ እና የአገር ደረጃ የመረጃ እና ትንተና ጥናቶች።",
    policiesReportsTitle: "የመንግስት እና የአጋሮች ሪፖርቶች",
    policiesReportsSubtitle: "የ AAAPD እና OPDs ስለ የአካል ጉዳት አካተት፣ ተደራሽነት እና የተሟጋትነት ውጤቶች ለማዘጋጀት እና ለሪፖርት የሚረዱ ቴምፕሌቶች እና ምሳሌዎች።",
    policiesToolkitsTitle: "መመሪያዎች እና ተግባራዊ መመሪያዎች",
    policiesToolkitsSubtitle: "ለፕሮግራም ንዑስ ንዑስ ንዑስ ንዑስ፣ ለማህበረሰብ ስራ፣ ለተካተተ ትምህርት እና ለመብት መሠረት ተሟጋትነት ዝግጁ መመሪያዎች።",
    
    // DonationPage
    donationHeroTitle: "ተልእኳችንን ይደግፉ - ህይወትን ያበረታቱ",
    donationHeroDesc1: "በአዲስ አበባ እና ከዚያም በላይ ያሉ አካል ጉዳተኞችን መሰናክሎችን በመስበር፣ ተጠቃሚነትን በማስፋፋትና አቅም በማጎልበት በጋራ መስራት እንችላለን።",
    donateNow: "አሁኑኑ ይለግሱ",
    whyDonateTitle: "ለምን ይለግሱ?",
    whyDonateDesc: "የእርስዎ ድጋፍ የአዲስ አበባ አካል ጉዳተኞች ማህበር (AAAPD) የአካል ጉዳተኞችን ሕይወት በእውነት እንዲነካ ያስችለዋል።",
    donateImpact1Title: "ስለ የአካል ጉዳት መብቶች ተሟጋችነት",
    donateImpact1Desc: "የአካል ጉዳተኞችን መብት ለማሳደግ የፖሊሲ ተሟጋችነት እና የሕግ አውጪ ምክክርን ይደግፉ።",
    donateImpact2Title: "የምልክት ቋንቋ ስልጠና",
    donateImpact2Desc: "ለኢትዮጵያ የምልክት ቋንቋ መምህራን እና ተተርጓሚዎች የስልጠና ፕሮግራሞችን ይደግፉ.",
    donateImpact3Title: "የተደራሽነት ፕሮጀክቶች",
    donateImpact3Desc: "በሕዝብ ቦታዎች ውስጥ ተደራሽነትን ማሻሻል እና የተካተተ መሠረተ ልማትን ማበረታታት.",
    donateImpact4Title: "የማህበረሰብ ማበረታቻ",
    donateImpact4Desc: "የአካል ጉዳት አውታረ መረቦችን ያበረታቱ እና የማህበረሰብ ተሳትፎ ተነሳሽነቶችን ይደግፉ.",
    donateImpact5Title: "የግንዛቤ ዘመቻዎች",
    donateImpact5Desc: "ስለ የአካል ጉዳት ግንዛቤ እና ማካተት የሚያበረታቱ የትምህርት ዘመቻዎችን ይደግፉ.",
    contributionMattersTitle: "ድጋፍዎ አስፈላጊ ነው",
    contributionMattersDesc: "ያበረከቱት አስተዋፅዖ ይበልጥ አካታች በሆነች አዲስ አበባ ላይ የሚደረግ ኢንቨስትመንት ነው። እያንዳንዱ ልገሳ አስፈላጊ ነው።",
    howToDonateTitle: "እንዴት ልናስተዋውቅ",
    howToDonateDesc: "ማበረታቻን እንዲቀርብ ቀላል እና ደህንነቱ የተጠበቀ አድርገናል.",
    bankTransferTitle: "በባንክ ለማስተላለፍ",
    cbeBankLabel: "የኢትዮጵያ ንግድ ባንክ",
    accountNameLabel: "የመለያ ስም:",
    accountNumberLabel: "የአካውንት ቁጥር:",
    swiftCodeLabel: "የSWIFT ኮድ:",
    thankYouTitle: "ስለ ድጋፍዎ እናመሰግናለን",
    thankYouDesc: "ልግስናችሁ በመላው አዲስ አበባ የአካል ጉዳተኞችን መብቶች፣ ተደራሽነት እና ማካተት በመሟገት ረገድ አስፈላጊ ስራችንን እንድንቀጥል ያስችለናል። እያንዳንዱ ልገሳ ለሁሉም ሰው እንቅፋት የሌለበት ከተማ ወደ ግባችን አንድ እርምጃ ያቀርበናል።",
    // Home CTA Section (Join Our Community)
    homeCtaTitle: "ማህበረሰባችንን ይቀላቀሉ",
    homeCtaDesc: "እንደ አካል ጉዳተኛ ይመዝገቡ እና ለድጋፍ፣ ግብዓቶች እና የማህበረሰብ ተሳትፎ ከአካባቢዎ ያሉ OPDs ጋር ይገናኙ።",
    homeCtaButton: "አሁን ይመዝገቡ",
    
    // News Articles
    featuredNewsTitle: "በአገር አቀፍ ደረጃ አዲስ የተደራሽነት ተነሳሽነት ተጀመረ",
    featuredNewsExcerpt: "በሀገሪቱ ውስጥ በሺዎች የሚቆጠሩ የአካል ጉዳተኞችን የሚጠቅም አጠቃላይ የተደራሽነት ተነሳሽነት መጀመራችንን በደስታ እናስታውቃለን። ይህ አዲስ ፕሮግራም መሠረተ ልማት፣ ትምህርት እና የስራ እድሎችን ማሻሻል ላይ ያተኮረ ነው።",
    featuredNewsDate: "ታህሳስ 15፣ 2024",
    featuredNewsAuthor: "የመገናኛ ቡድን",
    featuredNewsCategory: "ማስታወቂያ",
    
    news1Title: "የሙያ ስልጠና ፕሮግራም በተሳካ ሁኔታ ተጠናቀቀ",
    news1Excerpt: "ከ200 በላይ ተሳታፊዎች ከቅርብ ጊዜ የሙያ ስልጠና ፕሮግራማችን ተመርቀዋል፣ 85% ያህሉ ከስልጠናው በኋላ በሶስት ወር ውስጥ ስራ አግኝተዋል።",
    news1Date: "ታህሳስ 10፣ 2024",
    news1Author: "የፕሮግራም ዳይሬክተር",
    news1Category: "የስኬት ታሪክ",
    
    news2Title: "ከአካባቢ ዩኒቨርሲቲዎች ጋር ሽርክና ተገለጸ",
    news2Excerpt: "የስኮላርሺፕ እድሎችን እና ማካተት የሚችሉ የትምህርት ፕሮግራሞችን ለመስጠት ከአምስት ዋና ዩኒቨርሲቲዎች ጋር ስትራቴጂካዊ ሽርክና ፈጥረናል።",
    news2Date: "ታህሳስ 5፣ 2024",
    news2Author: "የትምህርት ቡድን",
    news2Category: "ሽርክና",
    
    news3Title: "አመታዊ ኮንፈረንስ 2024፡ ማካተት የሚችሉ ማህበረሰቦችን መገንባት",
    news3Excerpt: "ማካተት የሚችሉ ማህበረሰቦችን መገንባት ላይ ያተኮሩ ዋና ተናጋሪዎች፣ ወርክሾፖች እና የአውታረ መረብ እድሎች ያሉት አመታዊ ኮንፈረንሳችን ይቀላቀሉን።",
    news3Date: "ህዳር 28፣ 2024",
    news3Author: "የዝግጅት አስተባባሪ",
    news3Category: "ዝግጅት",
    
    news4Title: "አዲስ የጤና ድጋፍ ፕሮግራም ተጀመረ",
    news4Excerpt: "አዲሱ የጤና ድጋፍ ፕሮግራማችን ለተፈላጊ አባላት ነፃ የህክምና ምክር እና የእርዳታ መሳሪያዎችን ይሰጣል።",
    news4Date: "ህዳር 20፣ 2024",
    news4Author: "የጤና ቡድን",
    news4Category: "የፕሮግራም ማስጀመሪያ",
    
    news5Title: "የተሟገትነት ዘመቻ የፖሊሲ ለውጦችን አስመዘገበ",
    news5Excerpt: "የቅርብ ጊዜ የተሟገትነት ጥረቶቻችን በሕዝብ ማመላለሻ ውስጥ ተደራሽነትን የሚያሻሽሉ ጉልህ የፖሊሲ ለውጦችን አስከትለዋል።",
    news5Date: "ህዳር 15፣ 2024",
    news5Author: "የተሟገትነት ቡድን",
    news5Category: "ተሟገትነት",
    
    news6Title: "የማህበረሰብ ተደራሽነት ፕሮግራም ወደ ገጠር አካባቢዎች ተስፋፋ",
    news6Excerpt: "አስፈላጊ አገልግሎቶችን በጣም ለሚፈልጓቸው ሰዎች ቅርብ በማድረግ፣ የማህበረሰብ ተደራሽነት ፕሮግራማችንን ወደ አገልግሎት ያላገኙ ገጠር ማህበረሰቦች እያስፋፋን ነው።",
    news6Date: "ህዳር 10፣ 2024",
    news6Author: "የተደራሽነት አስተባባሪ",
    news6Category: "መስፋፋት",
    
    // ProgramsPage Section
    programsPageTitle: "የእኛ ፕሮግራሞች",
    programsPageSubtitle: "አካል ጉዳተኞችን ለማብቃት፣ ለመደገፍ እና ለማበረታታት በማህበረሰባችን ውስጥ የቀረፅናቸውን ጅማሮዎች ይቃኙ።",
    programsBrowseByCategory: "ፕሮግራሞችን በምድብ ይፈልጉ",
    programsClickCategoryToFilter: "ፕሮግራሞችን ለመፈልግ በምድብ ይምረጡ",
    programsSearchPlaceholder: "ፕሮግራሞችን ይፈልጉ...",
    programsAll: "ሁሉም",
    programsEmptyTitle: "ምንም ፕሮግራም አልተገኘም",
    programsEmptyDesc: "የፍለጋ ወይም የማጣሪያ ሁኔታዎችዎን ይለውጡ",
    programsTaglineTitle: "አካታች ወደፊትን በጋራ መገንባት",
    programsTaglineSub: "ፕሮግራሞቻችን ዘላቂ ተፅዕኖ ለመፍጠር እና አካል ጉዳተኞች ሙሉ አቅማቸውን እንዲጠቀሙ ለማብቃት ታስበው የተቀረፁ ናቸው።",
    programsImpactLabel: "ተጽዕኖ",
    descriptionLabel: "መግለጫ",
    programsKeyActivitiesLabel: "ዋና እንቅስቃሴዎች",
    closeButton: "ዝጋ",
    step1Title: "ደረጃ 1: ያግኙን",
    contactUs: "ያግኙን",
    programsStep2Desc: "ከቡድናችን ጋር የመጀመሪያ የምክክር ስምምነት ያድርጉ",
    programsGetStartedTitle: "ለመጀመር ዝግጁ ነዎት?",
    programsGetStartedDesc: "ወደ ማህበረሰባችን ተቀላቀሉ እና ፕሮግራሞቻችን እንዴት እንደሚያግዙዎት ይወቁ",
    programsStartJourney: "ጉዞዎን ይጀምሩ",
    whatWeOffer: "የምንሰጠው",
    whatWeOfferDesc: "ፕሮግራሞቻችን የአባላታችንን የተለያዩ ፍላጎቶች ለማሟላት የተዘጋጁ ናቸው።",
    learnMore: "ተጨማሪ ይወቁ",
    
    // Programs
    educationTitle: "ትምህርት እና ስኮላርሺፖች",
    educationDesc: "የአካል ጉዳተኛ ተማሪዎች የትምህርት ግባቸውን እንዲያሳኩ ለመርዳት ጥራት ያለው ትምህርት እና የስኮላርሺፕ እድሎች መዳረሻ መስጠት።",
    
    employmentTitle: "የሙያ ስልጠና እና ስራ",
    employmentDesc: "ግለሰቦችን በተግባራዊ ክህሎቶች ማስታጠቅ እና ከማካተት የሚችሉ አሰሪዎች ጋር በማገናኘት የገንዘብ ነፃነትን ማበረታታት።",
    
    healthcareTitle: "ጤና አጠባበቅ እና ማገገሚያ",
    healthcareDesc: "የህይወት ጥራትን ለማሻሻል አስፈላጊ የጤና አጠባበቅ አገልግሎቶች፣ የእርዳታ መሳሪያዎች እና የማገገሚያ ፕሮግራሞች ማቅረብ።",
    
    advocacyTitle: "ተሟገትነት እና ግንዛቤ",
    advocacyDesc: "የአካል ጉዳተኞችን መብት መከላከል እና የበለጠ ማካተት የሚችል እና ተደራሽ ማህበረሰብን ለማስፋፋት ዘመቻዎችን ማካሄድ።",
    
    communityTitle: "የማህበረሰብ ግንባታ ዝግጅቶች",
    communityDesc: "የማህበረሰብ ስሜትን ለማሳደግ፣ መገለልን ለመቀነስ እና ደጋፊ አውታረ መረቦችን ለመገንባት ማህበራዊ እና መዝናኛ ዝግጅቶችን ማዘጋጀት።",
    
    // How to Participate Section
    getInvolved: "ይሳተፉ",
    howToAccess: "ፕሮግራሞቻችንን እንዴት መድረስ ይቻላል",
    howToAccessDesc: "በፕሮግራሞቻችን አካል መሆን ቀላል ነው። ከእኛ ጋር ጉዞዎን ለመጀመር እነዚህን ደረጃዎች ይከተሉ።",
    
    step1Title: "1. አባል ይሁኑ",
    step1Desc: "ይፋዊ አባል ለመሆን እና የትስስር መረባችንን ለመቀላቀል፣ በአቅራቢያዎ በሚገኝ የአካል ጉዳተኞች ማህበር (OPD) ይመዝገቡ።",
    
    step2Title: "2. የፍላጎት ግምገማ",
    step2Desc: "ቡድናችን ልዩ ፍላጎቶችዎን እና ግቦችዎን ለመረዳት ከእርስዎ ጋር ይሰራል።",
    
    step3Title: "3. የፕሮግራም ምዝገባ",
    step3Desc: "ከፍላጎትዎ ጋር በጣም የሚስማሙ ፕሮግራሞች የምዝገባ ሂደት እንመራዎታለን።",
    
    // Programs Flow Section
    programsFlowTitle: "የእኛ ፕሮግራሞች እንዴት እንደሚሰሩ",
    programsFlow1Title: "ፍላጎቶችን መለየት",
    programsFlow1Desc: "ከማህበረሰቡ ጋር በቅርበት በመስራት በጣም አስፈላጊ የሆኑትን ፍላጎቶች እና ተግዳሮቶች እናሳያለን።",
    programsFlow2Title: "መፍትሄዎችን ማዘጋጀት",
    programsFlow2Desc: "ቡድናችን ለተለዩ ፍላጎቶች ምላሽ የሚሰጡ እና ሊለኩ የሚችሉ ውጤቶች ያላቸውን ልዩ ትኩረት የሚሰጡ ፕሮግራሞችን ይቀርጻል።  ",
    programsFlow3Title: "ፕሮግራሞችን ተግባራዊ ማድረግ",
    programsFlow3Desc: "የማህበረሰብ አባላት እና አጋሮች በንቃት በመሳተፍ ፕሮግራሞችን እናስፈጽማለን።",
    programsFlow4Title: "ውጤት መገምገም",
    programsFlow4Desc: "የመደበኛ ግምገማዎች ፕሮግራሞቻችን ትርጉም ያለው እና ዘላቂ ለውጥ እንዳመጡ ያረጋግጣሉ።",

    programsAccessInclusionTitle: "መድረሻ እና ትርትዖት",
    programsAccessItem1Title: "አካላዊ መድረሻ",
    programsAccessItem1Desc: "ሁሉም የእኛ ተቋማት እና ዝግጅቶች ለተለያዩ የአካል ጉዳተኞች ሙሉ በሙሉ የሚደርሱ ሆነው ተዘጋጅተዋል።",
    programsAccessItem2Title: "የግንኙነት ድጋፍ",
    programsAccessItem2Desc: "በፈቃደኝነት የምልክት ቋንቋ አስተርጓሚዎችን እና በተያያዥ ቅርጸ-ቁምፊዎች ያሉ ዕቃዎችን እናቀርባለን።",
    programsAccessItem3Title: "አካታች ዲዛይን",
    programsAccessItem3Desc: "ፕሮግራሞቻችን ሁሉንም ሰው በብቃት ለማገልገል የተለያዩ ዲዛይን መርሆችን በመጠቀም የተዘጋጁ ናቸው።",
    programsAccessItem4Title: "በግል ድጋፍ",
    programsAccessItem4Desc: "ለሁሉም አባላት ሙሉ ተሳትፎን ለማረጋገጥ ለእያንዳንዱ ግለሰብ የሚመጥኑ ማስተካከያዎች ይገኛሉ።",
    
    // CTA Section
    programsCTATitle: "ጥያቄዎች አሉዎት ወይም ከእኛ ጋር ለመተባበር ይፈልጋሉ?",
    programsCTADesc: "ተደራሽነታችንን እና ተፅዕኖአችንን ለማስፋት የሚረዱን አጋሮች እና በጎ ፈቃደኞች ሁልጊዜ እንፈልጋለን። እንዴት አስተዋፅዖ ማድረግ እንደሚችሉ ለማወቅ ያግኙን።",
    
    // FloatingSelfRegisterForm Section
    selfRegisterHere: "እዚህ ራስዎን ይመዝገቡ",
    selfRegistrationForm: "የራስ-ምዝገባ ቅጽ",
    selfRegistrationDesc: "የድጋፍ አገልግሎቶችን ለማግኘት ራስዎን ይመዝገቡ።",
    personalInformation: "የግል መረጃ",
    disabilityInformation: "የአካል ጉዳት መረጃ",
    selectDisabilityType: "የአካል ጉዳት አይነት ይምረጡ",
    addDisabilityType: "ሌላ ዓይነት የአካል ጉዳት ይጨምሩ",
    disabilityDescription: "የአካል ጉዳት መግለጫ",
    fullName: "ሙሉ ስም",
    fullNamePlaceholder: "ሙሉ ስምዎን ያስገቡ",
    gender: "ጾታ",
    male: "ወንድ",
    female: "ሴት",
    age: "እድሜ",
    agePlaceholder: "እድሜዎን ያስገቡ",
    phoneNumber: "ስልክ ቁጥር",
    phoneNumberPlaceholder: "ስልክ ቁጥርዎን ያስገቡ",
    disabilityType: "የአካል ጉዳት አይነት",
    idAttachment: "የመታወቂያ ሰነድ",
    idAttachmentPlaceholder: "የመታወቂያ ሰነድዎን ይላኩ",
    
    // Disability Types
    visualImpairment: "ዓይነ ስውር",
    hearingImpairment: "መስማት የተሳነው",
    PhysicalMobilityImpairment: "የአካል/የመንቀሳቀስ ችግር",
    IntellectualDisability: "የአዕምሮ እድገት ውስንነት",
    AutismNeurodivergence: "ኦቲዝም/የነርቭ ስርዓት እክል",
    mentalHealthCondition: "የአእምሮ ጤና እክል",
    chronicIllness: "ሥር የሰደደ ሕመም",
    speechImpairment: "የመናገር እክል",
    other: "የተለየ",
    
    // Address Information
    addressInformation: "የአድራሻ መረጃ",
    city: "ከተማ",
    cityPlaceholder: "ከተማዎን ያስገቡ",
    subcity: "ክፍለ ከተማ",
    wereda: "ወረዳ",
    weredaPlaceholder: "ወረዳዎን ያስገቡ",
    kebele: "ቀበሌ",
    kebelePlaceholder: "ቀበሌዎን ያስገቡ",
    houseNumber: "የቤት ቁጥር",
    houseNumberPlaceholder: "የቤት ቁጥርዎን ያስገቡ",
    
    // Additional Information
    additionalInformation: "ተጨማሪ መረጃ",
    messageDescription: "የመልእክት መግለጫ (አማራጭ)",
    messagePlaceholder: "ስለ ልዩ ፍላጎቶችዎ ወይም ማንኛውም ተጨማሪ መረጃ ይንገሩን...",
    
    // Form Actions
    cancel: "ሰርዝ",
    submitRegistration: "ምዝገባ አስገባ",
    submitting: "በማስገባት ላይ...",
    
    // Success/Error Messages
    registrationSuccessful: "ምዝገባ ተሳክቷል!",
    registrationSuccessDesc: "መረጃዎ ወደ OPD ተልኳል።",
    registrationFailed: "ምዝገባ አልተሳካም",
    
    // Validation Messages
    fullNameRequired: "ሙሉ ስም ያስፈልጋል",
    validAgeRequired: "ትክክለኛ እድሜ ያስፈልጋል",
    phoneNumberRequired: "ስልክ ቁጥር ያስፈልጋል",
    cityRequired: "ከተማ ያስፈልጋል",
    weredaRequired: "ወረዳ ያስፈልጋል",
    kebeleRequired: "ቀበሌ ያስፈልጋል",
    houseNumberRequired: "የቤት ቁጥር ያስፈልጋል",
    noOPDFound: "ለተመረጠው ክፍለ ከተማ ምንም OPD አልተገኘም።",
    submitFormFailed: "ቅጹን ማስገባት አልተሳካም። እባክዎ እንደገና ይሞክሩ።",
    
    // Gallery Section
    galleryTitle: "ጊዜያት እና ምዕራፎች",
    gallerySubtitle: "በማህበረሰባችን ውስጥ ያለውን ስራ እና ተፅዕኖ አንድ እይታ ይውሰዱ.",
    viewMore: "ተጨማሪ ይመልከቱ",
    // GalleryPage specific
    galleryPageTitle: "ጋለሪያችን",
    galleryEmptyTitle: "ምስሎች አልተገኙም",
    galleryEmptyDesc: "ጋለሪው በአሁኑ ጊዜ ባዶ ነው። እባክዎ በኋላ ይመለሱ አዳዲስ ምስሎችን ለማየት።",
    galleryReadMore: "ተጨማሪ አንብብ",
    galleryShowLess: "አጭር አሳይ",
    galleryImageFallback: "የጋለሪ ምስል",
    enlargedViewAlt: "ከፍ ተደረገ እይታ",
    
    // Contact Section
    contactTitle: "ያነጋግሩን",
    contactSubtitle: "ጥያቄዎች አሉዎት ወይም ከእኛ ጋር መተባበር ይፈልጋሉ? ከታች መልእክት ይተዉ።",
    contactMapTitle: "በካርታው ላይ ያግኙን",
    contactMapSubtitle: "የ AAAPD መሪ መሥሪያ ቤት እና የአጋር OPDs በአዲስ አበባ ዙሪያ.",
    livesImpacted: "የተደገፉ አባላት",
    yourName: "ስምዎ",
    emailAddress: "የኢሜይል አድራሻ",
    phoneNumber: "የስልክ ቁጥር",
    typeMessage: "መልእክትዎን ይጻፉ",
    sendMessage: "መልእክት ይላኩ",
    officeHours: "የቢሮ ሰዓቶች",
    mondayToFriday: "ሰኞ - አርብ",
    saturday: "ቅዳሜ",
    sunday: "እሁድ",

    // Login Page
    loginTitle: "ወደ መለያዎ ይግቡ",
    emailLabel: "ኢሜይል",
    passwordLabel: "የሚስጥር ቃል",
    rememberMe: "አስታውሰኝ",
    forgotPassword: "የይለፍ ቃል ረሱ?",
    loggingIn: "በመግባት ላይ...",
    loginButton: "ግባ",
    loginFailed: "መግባት አልተሳካም",
    networkOrServerError: "የኔትዎርክ ወይም የሰርቨር ስህተት",
    
    // Forgot Password Page
    fpTitleRequest: "የመለያ ይለፍ ቃልዎን ይቀይሩ",
    fpTitleVerify: "የማረጋገጫ ኮድ ያስገቡ",
    fpSubtitleRequest: "የኢሜይል አድራሻዎን ያስገቡ እና የማረጋገጫ ኮድ እንልክልዎታለን።",
    fpSubtitleVerify: "ኮዱን በኢሜይልዎ ያረጋግጡ ከዚያም አዲስ ይለፍ ቃል ያቀናብሩ.",
    fpEnterEmail: "እባክዎ የኢሜይል አድራሻዎን ያስገቡ",
    fpIfAccountExists: "መለያ ካለ፣ የመለያ መመለሻ ኮድ ወደ ኢሜይልዎ ተልኳል።",
    fpRequestFailed: "የይለፍ ቃል መመለሻ ጥያቄ አልተሳካም",
    fpEnterCode: "እባክዎ ወደ ኢሜይልዎ የተልከውን የማረጋገጫ ኮድ ያስገቡ።",
    fpPasswordMin: "ይለፍ ቃሉ ቢያንስ 8 ቁምፊዎች መሆን አለበት።",
    fpPasswordsMismatch: "ይለፍ ቃሎች አይመሳሰሉም።",
    fpResetSuccess: "ይለፍ ቃልዎ ተሳክቶ ተቀይሯል። እባክዎ ይግቡ።",
    fpResetFailed: "ይለፍ ቃል መቀየር አልተሳካም።",
    fpSending: "በመላክ ላይ...",
    fpSendCode: "ኮድ ላክ",
    fpVerificationCode: "የማረጋገጫ ኮድ",
    fpCodePlaceholder: "ወደ ኢሜይልዎ የተልከውን ኮድ ያስገቡ",
    fpNewPassword: "አዲስ ይለፍ ቃል",
    fpPasswordPlaceholder: "ቢያንስ 8 ቁምፊዎች",
    fpConfirmPassword: "ይለፍ ቃል ያረጋግጡ",
    back: "መመለስ",
    fpResetting: "በመቀየር ላይ...",
    fpResetPassword: "ይለፍ ቃል ቀይር",
    fpRememberPassword: "የይለፍ ቃልዎን ያስታውሳሉ?",
    fpBackToSignIn: "ወደ መግቢያ ተመለስ",
    closed: "ዝግ",
    whatsapp: "ዋትሳፕ",
    twitter: "ትዊተር",
    telegram: "ቴሌግራም",
    followUs: "ይከተሉን",
    
    // Accessibility Controls
    accHideControlsAria: "የተደራሽነት መቆጣጠሪያዎችን ደብቅ",
    accShowControlsAria: "የተደራሽነት መቆጣጠሪያዎችን አሳይ",
    accPanelTitle: "የተደራሽነት መቆጣጠሪያዎች",
    accCloseAria: "የተደራሽነት መቆጣጠሪያዎችን ዝጋ",
    accScreenReader: "ማንበብ መሳሪያ",
    accScreenReaderDisableAria: "ማንበብ መሳሪያን አቁም",
    accScreenReaderEnableAria: "ማንበብ መሳሪያን አብራ",
    accReading: "በመነበብ ላይ… (እንደገና ለማንበብ ጠቅ ያድርጉ)",
    accReadThisPage: "ይህን ገጽ አንብብ",
    accVoiceCommands: "የድምጽ ትእዛዛት",
    accVoiceDisableAria: "የድምጽ ትእዛዛትን አቁም",
    accVoiceEnableAria: "የድምጽ ትእዛዛትን አብራ",
    accListening: "በመስማት ላይ…",
    accStartVoice: "የድምጽ ትእዛዝ ጀምር",
    accVoiceSettings: "የድምጽ ቅንብሮች",
    accVoiceType: "የድምጽ አይነት",
    accVoiceDefault: "የነባሪ ድምፅ",
    accVoiceFemale: "የሴት ድምፅ",
    accVoiceMale: "የወንድ ድምፅ",
    accVoiceSlow: "ዝቅተኛ ፍጥነት",
    accVoiceFast: "ፈጣን ንግግር",
    accContrastMode: "የመለያየት ሁኔታ",
    accHighContrast: "ከፍተኛ መለያየት",
    accDefaultContrast: "መደበኛ",
    accTextSize: "የጽሑፍ መጠን",
    accSmallTextAria: "ትንሽ የጽሑፍ መጠን",
    accDefaultTextAria: "መደበኛ የጽሑፍ መጠን",
    accLargeTextAria: "ትልቅ የጽሑፍ መጠን",
    accExamplesTitle: "የድምጽ ትእዛዞች ምሳሌዎች:",
    accExReadPage: "\"ይህን ገጽ አንብብ\"",
    accExGoHome: "\"ወደ መነሻ ሂድ\"",
    accExGoWhoWeAre: "\"ወደ እኛ ማን ነን ሂድ\"",
    accExOpenPrograms: "\"ፕሮግራሞችን ክፈት\"",
    accExOpenGallery: "\"ጋለሪን ክፈት\"",
    accExGoContact: "\"ወደ እውቂያ ሂድ\"",
    accExIncreaseDecreaseText: "\"ጽሑፍን ከፍ አድርግ\" / \"ጽሑፍን አሳንስ\"",
    accExHighNormalContrast: "\"ከፍተኛ መለያየት\" / \"መደበኛ መለያየት\"",
    accExScroll: "\"ወደ ታች አንቀሳቅስ\" / \"ወደ ላይ አንቀሳቅስ\"",
    
    // Donor Impact Section
    donorImpactTitle: "የእርስዎ ተፅዕኖ ለውጥ ያመጣል",
    donorImpactSubtitle: "እያንዳንዱ ለጋስና በአዲስ አበባ ውስጥ ለአካል ጉዳተኞች ህይወት ላይ አወንታዊ ለውጥ የሚያመጣ ማዕበል ይፈጥራል። የእርስዎ ልግስና ማህበረሰቦችን እንዴት እንደሚቀይር እና ግለሰቦችን እንዴት እንደሚያበረታታ እነሆ።",
    donorImpactHighlight1: "አስፈላጊ የእንቅስቃሴ እርዳታዎችን መስጠት",
    donorImpactHighlight1Desc: "የእርስዎ አስተዋጽኦ ዊልቸር፣ ሽንት ቤት እና ሌሎች የእንቅስቃሴ መሳሪያዎችን ለማቅረብ ይረዳል፣ ይህም ለአካል ጉዳተኞች በተቀናጀ ሁኔታ ለመንቀሳቀስ እና በማህበረሰብ ህይወት ሙሉ ተሳትፎ እንዲያደርጉ ነፃነት ይሰጣል።",
    donorImpactHighlight2: "በህዝብ ቦታዎች ተደራሽነትን ማስፋፋት",
    donorImpactHighlight2Desc: "በትምህርት ቤቶች፣ ሆስፒታሎች እና ህዝብ ህንጻዎች ውስጥ የተደራሽነት ማሻሻያዎችን ደግፉ፣ ሁሉም ሰው አስፈላጊ አገልግሎቶችን እና እድሎችን ማግኘት የሚችልበት እንቅፋት የሌለበት አካባቢ ይፍጠሩ።",
    donorImpactHighlight3: "በአዲስ አበባ ውስጥ ያሉ OPDs ማብቃት",
    donorImpactHighlight3Desc: "የአካል ጉዳተኞች ድርጅቶችን (OPDs) በስልጠና፣ ሀብቶች እና የአቅም ግንባታ ፕሮግራሞች አጠናክሩ፣ ይህም የእነሱን ተሟጋትነት እና የአገልግሎት አቅርቦት ያጠናክራል።",
    donorImpactHighlight4: "የስራ እድሎችን መፍጠር",
    donorImpactHighlight4Desc: "ለአካል ጉዳተኞች ክህሎቶችን የሚያቀርቡ እና ከማካተት አሰሪዎች ጋር የሚያገናኙ የሙያ ስልጠና እና የስራ ፕሮግራሞችን ያግዙ፣ የገንዘብ ነፃነትን ያበረታታል።",
    donorImpactHighlight5: "ማካተት የሚችሉ ማህበረሰቦችን መገንባት",
    donorImpactHighlight5Desc: "መገለልን ለመቀነስ፣ ደጋፊ አውታረ መረቦችን ለመገንባት እና በሁሉም የማህበረሰብ አባላት መካከል ግንዛቤን ለማስተዋወቅ የማህበረሰብ ዝግጅቶችን፣ የግንዛቤ ዘመቻዎችን እና ማህበራዊ ፕሮግራሞችን ደግፉ።",
  }
};

export const useLanguage = () => {
  const getStoredLanguage = () => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('language') || 'en';
    }
    return 'en';
  };

  const setStoredLanguage = (lang) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('language', lang);
    }
  };

  return { getStoredLanguage, setStoredLanguage };
};
